import type { Dictionary } from '../types'

// ─── Turkish ────────────────────────────────────────────────────────────────

export const tr: Dictionary = {
  // ── Orders ──────────────────────────────────────────────────────────────
  orders: {
    title: 'Siparişler',
    searchPlaceholder: 'Sipariş no, e-posta, ad, telefon…',
    filtersToggle: 'Filtreleri aç/kapat',
    clearFilters: 'Filtreleri temizle',
    orderCount: '{count} sipariş',
    pageInfo: 'Sayfa {current}/{last}',

    colAmount: 'Tutar',
    colPayment: 'Ödeme',
    colDelivery: 'Teslimat',
    unitLabel: 'Birim:',
    itemCount: '{count} kalem',
    transferPayment: 'Havale/EFT',

    // Status labels
    statusAll: 'Tümü',
    statusPending: 'Bekliyor',
    statusProcessing: 'İşleniyor',
    statusShipped: 'Kargoda',
    statusDelivered: 'Teslim edildi',
    statusCompleted: 'Tamamlandı',
    statusCancelled: 'İptal',
    statusRefunded: 'İade',

    // Payment status
    paymentPending: 'Ödeme bekliyor',
    paymentPaid: 'Ödendi',
    paymentFailed: 'Başarısız',
    paymentPartialRefunded: 'Kısmi iade',

    // Fraud status
    fraudAll: 'Tümü',
    fraudNotRequired: 'Gerek yok',
    fraudPendingReview: 'İncelemede',
    fraudApproved: 'Onaylı',
    fraudDeclined: 'Reddedildi',

    // Smart status labels (non-React helpers)
    smartCancelled: 'İptal edildi',
    smartRefunded: 'İade edildi',
    smartShipped: 'Kargoya verildi',
    smartDelivered: 'Teslim edildi',
    smartProcessing: 'Sipariş işlemde',
    smartDeliveryPending: 'Teslimat bekliyor',
    smartPaymentPending: 'Ödeme bekliyor',

    // Payment type labels
    paymentTypeBalance: 'Bakiye',
    paymentTypeTransfer: 'Havale/EFT',
    paymentTypeCard: 'Kart',

    // List page errors / empty states
    loadError: 'Sipariş listesi alınamadı.',
    notFoundTitle: 'Sipariş bulunamadı',
    noMatchDescription: 'Filtrelere uyan kayıt yok.',
    openDetail: 'Detayı aç',

    // Date filter labels
    startDate: 'Başlangıç tarihi',
    endDate: 'Bitiş tarihi',

    // Detail page
    backToList: 'Sipariş listesine dön',
    orderTitle: 'Sipariş {number}',
    detailTitle: 'Sipariş Detayı',
    downloadPdfAriaLabel: 'Sipariş detayları PDF indir',
    pdfDownloaded: 'Sipariş detayları PDF indirildi.',
    pdfFailed: 'PDF oluşturulamadı.',
    detailPdf: 'Detay PDF',

    summarySection: 'Özet',
    paymentLabel: 'Ödeme:',
    fraudLabel: 'Fraud:',
    createdAtLabel: 'Oluşturma:',
    customerNameLabel: 'Ad',
    customerAccount: 'Hesap',
    itemsSection: 'Kalemler',
    unitPriceLabel: 'Birim',
    lineTotalLabel: 'Satır',
    paymentsSection: 'Ödemeler',
    paymentCount: 'ödeme',
    approveTransfer: 'Havale Onayla',
    reject: 'Reddet',
    approve: 'Onayla',
    updateStatus: 'Durum güncelle',
    orderStatusLabel: 'Sipariş durumu *',
    cancelReasonLabel: 'İptal / not nedeni',
    cargoProvider: 'Kargo sağlayıcı',
    trackingNumber: 'Takip numarası',
    fraudStatusLabel: 'Fraud durumu',
    fraudKeepCurrent: 'Değiştirme',
    saving: 'Kaydediliyor…',
    saveStatus: 'Durumu kaydet',
    liveTracking: 'Canlı kargo takibi',
    lastStatus: 'Son durum:',
    selectIntegration: 'Entegrasyon seçin…',
    trackingFailed: 'Kargo sorgulaması başarısız.',
    querying: 'Sorgulanıyor…',
    query: 'Sorgula',
    statusHistory: 'Durum geçmişi',
    activityLog: 'Günlük',
    refundSection: 'İade',
    refundAmountLabel: 'İade tutarı',
    refundFullHint: 'boş = tam iade',
    reason: 'Neden',
    processing: 'İşleniyor…',
    startRefund: 'İade başlat',

    statusUpdated: 'Sipariş durumu güncellendi.',
    refundSuccess: 'İade başarılı',
    transferApproved: 'Havale onaylandı — sipariş işleme alındı',
    transferRejected: 'Havale ödemesi reddedildi',
    transferActionFailed: 'Havale onay/red işlemi başarısız.',
    invalidOrder: 'Geçersiz sipariş.',
    loadDetailError: 'Sipariş yüklenemedi.',

    // Modal extras
    fullPage: 'Tam sayfa',
    openFullPage: 'Tam sayfada aç',
    paid: 'Ödenen',
    tabOverview: 'Genel bakış',
    tabFinancial: 'Finansal',
    tabManage: 'Yönetim',
    tabHistory: 'Geçmiş',
    customerFullName: 'Ad soyad',
    tcNo: 'TC',
    company: 'Firma',
    taxNumber: 'Vergi no',
    deliveryAddress: 'Teslimat adresi',
    fraudReason: 'Fraud nedeni',
    cancelReason: 'İptal nedeni',
    coupon: 'Kupon',
    source: 'Kaynak',
    externalNo: 'Harici no',
    ipAddress: 'IP',
    cargoFirm: 'Kargo firma',
    trackingNo: 'Takip no',
    cargoStatusLabel: 'Kargo durum',
    noMeta: 'Ek sipariş meta yok.',
    billingInfo: 'Fatura bilgileri',
    billingName: 'Ünvan / Ad',
    taxOffice: 'Vergi dairesi',
    billingAddress: 'Fatura adresi',
    grossRevenue: 'Gelir',
    cost: 'Maliyet',
    netProfit: 'Net kâr',
    margin: 'Marj',
    noPaymentRecord: 'Ödeme kaydı yok.',
    amountLabel: 'Tutar:',
    commissionLabel: 'Komisyon:',
    paymentDateLabel: 'Tarih:',
    cardLabel: 'Kart:',
    bankLabel: 'Banka:',
    transferSender: 'Havale:',
    pendingTransferNotice: 'Bekleyen havale bildirimi var — onay sonrası sipariş işleme alınır.',
    costSummary: 'Maliyet özeti',
    grossSales: 'Ürün satışı',
    itemDiscount: 'Kalem indirimi',
    netRevenue: 'Net gelir',
    productCost: 'Ürün maliyeti',
    costLabel: 'Maliyet',
    showCosts: 'Maliyetleri göster',
    hideCosts: 'Maliyetleri gizle',
    costHint: 'Maliyet/kâr için üstteki "Maliyet" düğmesine basın',
    statusCargoFraud: 'Durum / kargo / fraud',
    cargoFirmLabel: 'Kargo firması',
    cancelReasonNote: 'İptal / not nedeni',
    cargoPlaceholder: 'Yurtiçi, MNG…',
    trackingPlaceholder: 'Takip no',
    noHistory: 'Henüz geçmiş kaydı yok.',

    // Delivery address
    deliveryAddressLabel: 'Teslimat adresi',
    billingAddressLabel: 'Fatura adresi',

    // Line item detail
    requestedFields: 'Talep edilen bilgiler',
    deliverySection: 'Teslimat',
    processedAt: 'İşleme',
    deliveredAt: 'Teslim',
    deliveredBy: 'Teslim eden',
    cargoTrackLabel: 'Kargo takip',
    notYetDelivered: 'Henüz teslim edilmedi',
    cancelItemReason: 'İptal:',

    // Pending delivery section
    pendingDeliveryTitle: 'Teslimat Bekleyen',
    pendingDeliveryToggle: 'Teslimat bekleyen bölümünü aç/kapat',
    pendingDeliveryError: 'Teslimat kuyruğu yüklenemedi.',
    noPendingItems: 'Teslimat bekleyen kalem yok.',
    deliveryNotePlaceholder: 'Teslimat notu…',
    deliveryNoteLabel: 'Teslimat notu',
    openOrderDetail: 'Sipariş detayını aç',
    epinStockTitle: 'E-pin stok ekle',
    epinInstructions: 'En az {qty} kod girin (her satıra bir kod). Eklenen kodlar kaydedilir ve kalem otomatik teslim edilir.',
    epinCodesLabel: 'E-pin kodları',
    epinAdded: 'E-pin eklendi ve teslim edildi.',
    stockAddFailed: 'Stok eklenemedi.',
    addAndDeliver: 'Ekle ve teslim et',
    stockBadge: 'Stok',
    take: 'Al',
    release: 'Bırak',
    deliver: 'Teslim',
    locked: 'Kilitli',
    takeAction: 'İşleme al',
    releaseAction: 'Bırak',
    deliverAction: 'Teslim et',
    itemTaken: 'Kalem işleme alındı.',
    itemTakeFailed: 'İşleme alınamadı.',
    itemReleased: 'Kalem bırakıldı.',
    itemReleaseFailed: 'Bırakılamadı.',
    deliveredDot: 'Teslim edildi.',
    deliverFailed: 'Teslim edilemedi.',
    itemsTaken: 'Kalemler işleme alındı.',
    itemsDelivered: 'Kalemler teslim edildi.',
    lockedBy: 'Kilit · {user}',

    // Delivery cell
    cancelledBadge: 'İptal edildi',
    deliveredBadge: 'Teslim edildi',
    transferApprovalLabel: 'Havale onayı',
    noPayment: 'Ödeme yok',
    paidBadge: 'Ödendi',
    approveTransferAriaLabel: 'Havale onayla',
    rejectTransferAriaLabel: 'Havale reddet',
    cancelOrderAriaLabel: 'Siparişi iptal et',
    cancelAction: 'İptal',
    takeRemaining: 'Kalan kalemleri işleme al',
    myItems: '{mine}/{total} sende',
    lockedItems: '{count} kilit',

    // Cancel modal
    cancelModalTitle: 'Siparişi İptal Et',
    cancelRefundWarning: 'Bu sipariş için yapılan ödemeler de iptal/iade edilecektir!',
    cancelNoPaymentWarning: 'Ödeme alınmamış sipariş iptal edilecek.',
    refundMethodTitle: 'Ödeme İade Yöntemi',
    refundMethodSubtitle: 'Ödemelerin nasıl iade edileceğini seçin',
    refundToBalance: 'Bakiyeye İade Et',
    refundToBalanceDesc: 'Ödeme tutarı müşterinin hesap bakiyesine eklenir',
    refundToCard: 'Karta İade Et',
    refundToCardDesc: 'Ödeme tutarı ödeme yapılan karta geri gönderilir',
    cancelOnly: 'İptal Et',
    cancelOnlyDesc: 'Ödeme işlemi tamamen iptal edilir, iade yapılmaz',
    cancelReasonTitle: 'İptal nedeni',
    cancelReasonPlaceholder: 'İptal nedeni seçin...',
    cancelReasonOther: 'Diğer (Açıklama ekle)',
    otherReasonPlaceholder: 'İptal nedenini yazın...',
    otherReasonLabel: 'Diğer iptal nedeni',
    cancelReasonRequired: 'İptal nedeni seçilmelidir.',
    otherReasonRequired: 'Diğer neden için açıklama yazın.',
    cancelSuccess: 'Sipariş iptal edildi.',
    cancelFailed: 'İptal edilemedi.',
    cancelOrderButton: 'Siparişi İptal Et',
  },

  // ── Payments ─────────────────────────────────────────────────────────────
  payments: {
    // Notifications page
    notifTitle: 'Ödeme Bildirimleri',
    notifDescription: 'Havale/EFT bildirimlerini inceleyin, onaylayın veya reddedin. Tüm ödeme işlemlerini diğer sekmeden takip edin.',
    tabTransfer: 'Havale onayları',
    tabAll: 'Tüm ödemeler',

    // Status filter options
    allStatuses: 'Tüm durumlar',
    statusAwaitingApproval: 'Onay bekliyor',
    statusApproved: 'Onaylandı',
    statusRejected: 'Reddedildi',
    statusPending: 'Bekliyor',
    statusCompleted: 'Tamamlandı',
    statusFailed: 'Başarısız',
    statusRefunded: 'İade edildi',
    statusCancelled: 'İptal',

    // Type filter options
    allTypes: 'Tüm tipler',
    typeTransfer: 'Havale/EFT',
    typeBalance: 'Bakiye',
    typeIyzico: 'İyzico',
    typePaytr: 'PayTR',
    typeStripe: 'Stripe',
    typePapara: 'Papara',
    typeVallet: 'Vallet',
    typeManual: 'Manuel',

    // Filters
    filterSearchPlaceholder: 'Sipariş / Ad / Telefon / Not',
    filterSearchAriaLabel: 'Ödeme arama',
    filterStatusAriaLabel: 'Durum filtresi',
    filterTypeAriaLabel: 'Ödeme tipi filtresi',
    filterButton: 'Filtrele',

    // Table columns – notifications
    colOrder: 'Sipariş',
    colSender: 'Gönderen',
    colBank: 'Banka',
    colBankAccount: 'Havale hesabı',
    colDates: 'Tarihler',
    colNoteReceipt: 'Not / Dekont',
    colStatus: 'Durum',
    colActions: 'İşlem',
    colType: 'Ödeme tipi',
    colAmount: 'Tutar',
    colPaymentDate: 'Ödeme',
    colNotifDate: 'Bildirim',
    colDecont: 'Dekont',

    // Table columns – transactions
    colId: '#ID',
    colRefund: 'İade',
    colDate: 'Tarih',
    colCustomer: 'Müşteri',

    // Actions
    approve: 'Onayla',
    reject: 'Reddet',
    openReceipt: 'Dekontu aç',

    // Detail panel
    detailTitle: 'Bildirim detayı',
    clickRowHint: 'Detay için bir satıra tıklayın',
    clickRowSubHint: 'Gönderen, IBAN, TC ve not burada görünür.',
    amountLabel: 'Tutar',
    senderLabel: 'Gönderen',
    tcLabel: 'T.C.',
    paymentDateDetail: 'Ödeme tarihi',
    bankAccountLabel: 'Banka hesabı',
    ibanCopy: 'IBAN kopyala',

    // Feedback
    approvedSuccess: 'Havale onaylandı — sipariş işleme alındı',
    rejectedSuccess: 'Bildirim reddedildi',
    statusUpdated: 'Durum güncellendi',
    actionFailed: 'İşlem başarısız oldu',
    noPendingNotif: 'Onay bekleyen havale bildirimi yok. Siparişler\'de bekleyen havale varsa bu sayfa yenilenince otomatik listelenir.',
    noPaymentRecords: 'Ödeme kaydı bulunamadı.',

    // Transactions page
    transactionsTitle: 'Ödeme İşlemleri',
    totalRecords: 'Toplam {count} kayıt',

    // Balance requests page
    balanceTitle: 'Bakiye Çekimleri',
    totalRequests: 'Toplam {count} talep',
    transactionCodeLabel: 'İşlem kodu',
    transactionCodePlaceholder: 'İşlem kodu ara…',
    noWithdrawals: 'Bakiye çekimi talebi bulunamadı.',
    colTransactionCode: 'İşlem Kodu',
    colMethod: 'Yöntem',
    colDescription: 'Açıklama',

    // Transaction detail page
    detail: {
      invalidId: 'Geçersiz işlem ID.',
      loadFailed: 'İşlem yüklenemedi.',
      backToList: 'Listeye dön',
      title: 'Ödeme İşlemi #',
      infoTitle: 'İşlem Bilgileri',
      amountLabel: 'Tutar',
      paymentType: 'Ödeme tipi',
      refundType: 'İade tipi',
      commission: 'Komisyon',
      createdAt: 'Oluşturma',
      updatedAt: 'Güncelleme',
      noteDesc: 'Not / Açıklama',
      providerTitle: 'Ödeme Sağlayıcı',
      providerName: 'Ad',
      providerKey: 'Anahtar',
      balanceTxTitle: 'Bakiye İşlemi',
      refundTitle: 'İade İşlemi',
      refundAmount: 'İade tutarı',
      refundAmountHint: '(boş bırakılırsa tam iade: {amount})',
      refundReason: 'Neden',
      processing: 'İşleniyor…',
      initiateRefund: 'İade başlat',
      alreadyRefunded: 'Bu ödeme zaten iade edildi ({type}).',
      onlyCompletedRefundable: 'Yalnızca tamamlanmış ödemeler iade edilebilir.',
      balanceNotRefundable: 'Bakiye ödemeleri bu ekrandan iade edilmez.',
      orderRequiredForRefund: 'İade için sipariş gereklidir.',
      refundSuccess: 'İade başarılı — {type} {amount} TL',
      fullRefund: 'Tam iade',
      partialRefund: 'Kısmi iade',
      orderNotFound: 'Sipariş bulunamadı.',
    },
  },

  // ── Fraud ─────────────────────────────────────────────────────────────────
  fraud: {
    title: 'Şüpheli İşlemler',
    rulesTitle: 'Fraud kuralları',
    rulesDesc: 'Sipariş tutarı ve hız limitleri — şüpheli işlem eşikleri.',

    statusAll: 'Tümü',
    statusPending: 'Bekliyor',
    statusApproved: 'Onaylı',
    statusRejected: 'Reddedildi',

    colOrder: 'Sipariş',
    colDocType: 'Belge Türü',
    colFile: 'Dosya',
    colStatus: 'Durum',
    colDate: 'Tarih',
    colActions: 'İşlem',

    approve: 'Onayla',
    reject: 'Reddet',
    approveDocTitle: 'Belgeyi Onayla',
    rejectDocTitle: 'Belgeyi Reddet',
    reasonOptional: 'Neden (isteğe bağlı)',
    approveSuccess: 'Belge onaylandı.',
    rejectSuccess: 'Belge reddedildi.',
    actionFailed: 'İşlem başarısız.',
    orderLabel: 'Sipariş:',
  },

  // ── Marketplace ───────────────────────────────────────────────────────────
  marketplace: {
    title: 'Mağaza Listesi',
    commissionsTitle: 'Marketplace Entegrasyonu',
    applicationsTitle: 'Mağaza Başvuruları',
    pricesTitle: 'Mağaza Ürün Fiyatları',
    pricesInfo: 'Çift tıkla · birden fazla satır · toplu kaydet · tekrar çift tık = satır iptal · sınırlar modalda',

    colStore: 'Mağaza',
    colLevel: 'Seviye',
    colBalance: 'Bakiye',
    colPending: 'Bekleyen',
    colStatus: 'Durum',
    colActions: 'İşlem',

    newStore: 'Yeni Mağaza',
    editStore: 'Mağaza Düzenle',
    addProductToStore: 'Mağazaya Ürün Ekle',
    totalCount: 'Toplam {count}',

    // Stores table filter / search
    searchPlaceholder: 'Ara…',
    allStoresFilter: 'Tüm Mağazalar',
    allCategoriesFilter: 'Tüm Kategoriler',
    allVirtualStocksFilter: 'Tüm Sanal Stoklar',
    unassignedVirtualStock: 'Sanal Stok Atanmamış',
    allTypesFilter: 'Tüm Türler',
    apiProducts: 'API Ürünleri',
    virtualStockProducts: 'Sanal Stok Ürünleri',
    allStatusesFilter: 'Tüm Durumlar',
    productSearchPlaceholder: 'Ürün veya mağaza ara…',
    pageSizeLabel: 'Sayfa başına',
    totalProducts: 'Toplam {count} ürün',
    rangeShowing: '{from}–{to} arası gösteriliyor',

    // Form
    storeNameLabel: 'Mağaza Adı *',
    descriptionLabel: 'Açıklama',
    levelLabel: 'Seviye',
    paymentDayLabel: 'Ödeme Günü',
    logoHint: 'Logo seç (kayıttan sonra yüklenir)',
    removeLogoSelection: 'Seçimi kaldır',
    onlyImageError: 'Yalnızca görsel dosyalar yüklenebilir.',
    fileSizeError: 'Dosya boyutu 2 MB\'ı geçemez.',
    storeCreatedLogoFailed: 'Mağaza oluşturuldu ancak logo yüklenemedi. Düzenle ekranından tekrar deneyin.',
    storeSaved: 'Güncellendi.',
    storeCreated: 'Oluşturuldu.',
    storeDeleted: 'Silindi.',
    storeDeleteFailed: 'Silinemedi.',
    storeSaveFailed: 'İşlem başarısız.',

    // Commission tabs
    tabRules: 'Komisyon Kuralları',
    tabSync: 'Senkronizasyon',
    tabCalc: 'Hesaplama',
    allStores: 'Tüm mağazalar',
    newRule: 'Yeni Kural',
    editRule: 'Kural Düzenle',
    newCommissionRule: 'Yeni Komisyon Kuralı',
    ruleNameLabel: 'Kural Adı',
    ruleNamePlaceholder: 'Örn: Genel Komisyon',
    storeSelectLabel: 'Mağaza',
    rateLabel: 'Oran (%)',
    fixedFeeLabel: 'Sabit Ücret (₺)',
    minCommLabel: 'Min. Komisyon (₺)',
    maxCommLabel: 'Max. Komisyon (₺, 0=sınırsız)',
    saving: 'Kaydediliyor…',
    noRulesYet: 'Henüz komisyon kuralı yok.',
    colRuleName: 'Kural Adı',
    colRate: 'Oran',
    colFixed: 'Sabit',
    colCategory: 'Kategori',
    colGeneral: 'Genel',

    // Sync tab
    connectionTest: 'Bağlantı Testi',
    testing: 'Test ediliyor…',
    pullOrders: 'Siparişleri Çek',
    pulling: 'Çekiliyor…',
    connectionError: 'Bağlantı hatası.',
    pullFailed: 'Sipariş çekme hatası.',

    // Calculator tab
    calcTitle: 'Komisyon Hesaplama',
    salePriceLabel: 'Satış Fiyatı (₺)',
    calculate: 'Hesapla',
    salesPrice: 'Satış Fiyatı',
    commission: 'Komisyon',
    netEarning: 'Net Kazanç',

    // Applications
    appStatusAll: 'Tümü',
    appStatusPending: 'Bekliyor',
    appStatusApproved: 'Onaylı',
    appStatusRejected: 'Reddedildi',
    colCompany: 'Firma',
    colContact: 'İletişim',
    colWeb: 'Web',
    colApplicationDate: 'Başvuru Tarihi',
    reviewLabel: 'İncele',
    contactTitle: 'Yetkili',
    taxIdLabel: 'VKN',
    applicationDescLabel: 'Başvuru Açıklaması',
    reviewTitle: 'Değerlendirme',
    adminNoteLabel: 'Admin Notu',
    adminNotePlaceholder: 'İsteğe bağlı not…',
    approveWithStore: 'Onayla ve Mağaza Oluştur',
    applicationApproved: 'Başvuru onaylandı.',
    applicationRejected: 'Başvuru reddedildi.',
    applicationActionFailed: 'İşlem başarısız.',
    noApplications: 'Başvuru bulunamadı.',

    // Price table
    priceDeleted: 'Mağaza fiyatı silindi.',
    priceDeleteFailed: 'Silinemedi.',
    priceDeleteConfirm: 'Bu mağaza fiyat kaydını silmek istediğinizden emin misiniz?',

    // Applications detail modal
    detailModalTitle: 'Başvuru Detayı',
    companyNameLabel: 'Firma Adı',
    approveLabel: 'Onayla',
    rejectLabel: 'Reddet',

    // Price table columns
    colId: '# (ID)',
    colCost: 'Maliyet',
    colSale: 'Satış',
    colDealer: 'Bayi',
    colBuy: 'Alış',
    colMarket: 'Market',
    colBuySaleLimits: 'Alış/Satış Sınırları',
    colBuyMinMax: 'Alış A/K',
    colStockCount: 'Stok Adeti',
    colStockRequired: 'Stok Gerekli',
    colApiSale: 'API Satış',
    colApiStock: 'API Stok',

    // Price table toggle feedback
    statusUpdated: 'Durum güncellendi.',
    buyStatusUpdated: 'Alış durumu güncellendi.',
    stockRequiredUpdated: 'Stok gerekli güncellendi.',
    apiSaleUpdated: 'API satış güncellendi.',
    apiStockUpdated: 'API stok güncellendi.',

    // Price table UI
    sortAria: '{col} sırala',
    viewProductAria: 'Ürünü görüntüle',
    noStockLabel: 'Stok yok',
    editingRows: '{count} satır düzenleniyor',
    saveAll: 'Tümünü Kaydet',
    cancelAll: 'Tümünü İptal',
    physicalPrefix: 'Fiziksel: ',
    apiPrefix: 'API: ',
    virtualPrefix: 'Sanal: ',
    priceTypeProduct: 'Ürün',
    priceTypeApiProduct: 'API Ürünü',
    priceTypeVirtualStock: 'Sanal Stok',
    priceTypeSelectVirtualStock: 'Sanal Stok Seçiniz!',
    openLabel: 'Açık',
    closedLabel: 'Kapalı',

    // Price table tooltips
    salePriceRatioTip: 'Maliyet üzerine oran ekler (ör. maliyet 80, oran 25 → satış 100).',
    fixedPriceTip: 'Sabit/Tutar: nihai fiyatı doğrudan TL olarak siz girersiniz; oran alanı kullanılmaz.',
    saleRateTip: 'Maliyet üzerine eklenecek yüzde oranı. Tip "Yüzde" iken satış fiyatı otomatik hesaplanır.',
    saleFinalTip: 'Nihai satış fiyatı. Tip "Yüzde" iken otomatik dolar; "Sabit/Tutar" iken siz girersiniz.',
    buyPriceTip: 'Alış fiyatı maliyet üzerinden belirlenir. Yüzde 0: alış = maliyet. Yüzde: maliyet + oran. Negatif oran veya Sabit/Tutar ile maliyetin altına da inebilirsiniz.',
    buyRateTip: 'Maliyet üzerine eklenecek yüzde oranı. 0 iken alış maliyete eşittir; negatif oran maliyetin altına indirir.',
    buyFinalTip: 'Nihai alış fiyatı. Tip "Yüzde" iken maliyetten otomatik hesaplanır; "Sabit/Tutar" iken siz girersiniz.',
    dealerPriceTip: 'Bayi fiyatı satış fiyatına göre belirlenir. Yüzde: satıştan indirim. Sabit/Tutar: nihai fiyatı doğrudan TL olarak siz girersiniz; oran alanı kullanılmaz.',
    dealerRateTip: 'Satış fiyatından düşülecek yüzde oranı. Tip "Yüzde" iken bayi fiyatı otomatik hesaplanır.',
    dealerFinalTip: 'Nihai bayi fiyatı. Tip "Yüzde" iken otomatik dolar; "Sabit/Tutar" iken siz girersiniz.',
    selectStoreFirstTip: 'Önce mağazayı seçin. Ürün listesi seçilen mağazaya göre yüklenir.',
    searchNotAddedTip: 'Mağazaya henüz eklenmemiş aktif ürünler arasından arama yaparak seçim yapın.',
    marketPriceTip: 'Ürün kartındaki referans (üstü çizili) fiyat. Ürün kaydından gelir; mağaza fiyatından bağımsızdır.',
    costUpdateTip: 'Maliyet değişince yüzde tipindeki satış ve alış fiyatları otomatik yeniden hesaplanır.',
    stockRequiredTip: 'Stok zorunlu (fiziksel/sanal/API)',
    stockRequiredOffTip: 'Kapalı = stoksuz satış',
    apiSaleTip: 'Ödeme→sağlayıcı sipariş',
    apiStockTip: 'Vitrin stok kaynağı',
    statusTip: 'Mağaza durumu',

    // Product modal
    modalEditTitle: 'Mağaza Fiyatını Düzenle',
    apiEnabled: 'API Kullanılsın',
    botEnabled: 'Bot Kullanılsın',
    pointSale: 'Puan İle Satılsın',
    selectStorePlaceholder: 'Mağaza Seçiniz',
    selectStoreLabel: 'Mağaza Seç',
    selectProductPlaceholder: 'Ürün Seçiniz',
    selectProductLabel: 'Ürün ara ve seç',
    selectStoreFirstHint: 'Önce mağaza seçin',
    virtualStockNotConnected: 'Bağlı Değil',
    virtualStockSelectLabel: 'Sanal Stok Seç',
    pointAmountLabel: 'Satın Alınabilecek Puan Miktarı',
    apiProviderHint: 'Harici stok/tedarik API sağlayıcısını arayarak seçin.',
    apiProviderLabel: 'API Sağlayıcısı',
    apiProviderSearch: 'API sağlayıcı ara',
    turkpinGameHint: 'TurkPin için oyun/kategori seçimi zorunludur.',
    apiGameLabel: 'API Oyun',
    apiGameSearch: 'Oyun ara',
    apiGameSelectFirst: 'Önce API seçin',
    apiProductHint: 'Seçilen sağlayıcıdaki ürünü arayarak eşleştirin.',
    apiProductLabel: 'API Ürün',
    apiProductSearch: 'API ürün ara',
    apiFieldMappingTitle: 'API Zorunlu Alan Eşleştirmesi',
    apiStoreFieldSelect: 'Mağaza alanı seçin',
    apiFetchPriceFailed: 'API fiyat bilgisi alınamadı.',
    apiFetchPriceSuccess: 'Maliyet API fiyatı ile güncellendi.',
    apiFetchPriceError: 'API fiyatı alınamadı',
    apiFetchPriceRequireFields: 'Önce API sağlayıcısı ve API ürünü seçin.',
    apiTurkpinGameFirst: 'TurkPin için önce oyun seçin.',
    apiFetchPriceLabel: 'API Fiyatını Getir',
    botProductLabel: 'Bot Ürünü',
    botProductSearch: 'Bot ürünü seç',
    selectOption: 'Seçiniz',
    costRecalcLabel: 'Fiyatları yeniden hesapla',
    marketPriceLabel: 'Market Fiyatı',
    currencyHint: 'Mağaza fiyatlandırmasında kullanılacak para birimi.',
    currencyLabel: 'Para Birimi',
    salePriceTypeLabel: 'Satış Fiyat. Tipi',
    saleRateLabel: 'Satış Oran Miktarı',
    saleAutoLabel: 'Satış Fiyatı (Oto)',
    buyPriceTypeLabel: 'Alış Fiyat. Tipi',
    buyRateLabel: 'Alış Oran Miktarı',
    buyAutoLabel: 'Alış Fiyatı (Oto)',
    dealerPriceTypeLabel: 'Bayi Fiyat. Tipi',
    dealerRateLabel: 'Bayi Oran Miktarı',
    dealerAutoLabel: 'Bayi Fiyatı (Oto)',
    saleLimitsTitle: 'Satış Saatleri ve Satış Sınırlamaları',
    saleLimitsHint: 'Ürünün yalnızca belirli saatlerde satışa açık olmasını istiyorsanız bu alanları doldurabilirsiniz.',
    saleLimitsSection: 'Satış Sınırları',
    startHourLabel: 'Başlangıç Saati (0-23)',
    endHourLabel: 'Bitiş Saati (0-23)',
    minAmountLabel: 'Min. Miktar',
    maxAmountLabel: 'Maks. Miktar',
    buyLimitsSection: 'Alış Sınırları',
    priceUpdated: 'Mağaza fiyatı güncellendi.',
    productAdded: 'Ürün mağazaya eklendi.',
    priceUpdateFailed: 'Güncellenemedi',
    priceAddFailed: 'Eklenemedi',
    editingRecordNotFound: 'Düzenlenecek kayıt bulunamadı.',

    applications: {
      title: 'Mağaza Başvuruları',
      tabAll: 'Tümü',
      tabPending: 'Bekliyor',
      tabApproved: 'Onaylı',
      tabRejected: 'Reddedildi',
      statusPending: 'Bekliyor',
      statusApproved: 'Onaylandı',
      colFirm: 'Firma',
      colContact: 'İletişim',
      colWeb: 'Web',
      colDate: 'Başvuru Tarihi',
      noResults: 'Başvuru bulunamadı.',
      review: 'İncele',
      authorized: 'Yetkili',
      applicationDesc: 'Başvuru Açıklaması',
      evaluation: 'Değerlendirme',
      adminNote: 'Admin Notu',
      notePlaceholder: 'İsteğe bağlı not…',
      approveAndCreate: 'Onayla ve Mağaza Oluştur',
      approvedMsg: 'Başvuru onaylandı.',
      rejectedMsg: 'Başvuru reddedildi.',
    },

    prices: {
      title: 'Mağaza Ürün Fiyatları',
      titleAriaLabel: 'Mağaza ürün fiyatları kullanım bilgisi',
      pageInfoTip: 'Çift tıkla · birden fazla satır · toplu kaydet · tekrar çift tık = satır iptal · sınırlar modalda',
      recordsCount: '{count} kayıt',
      addProduct: 'Mağazaya Ürün Ekle',
      allStores: 'Tüm Mağazalar',
      allCategories: 'Tüm Kategoriler',
      allVirtualStocks: 'Tüm Sanal Stoklar',
      unassignedVirtualStock: 'Sanal Stok Atanmamış',
      allTypes: 'Tüm Türler',
      apiProducts: 'API Ürünleri',
      virtualStockProducts: 'Sanal Stok Ürünleri',
      allStatuses: 'Tüm Durumlar',
      storeFilterLabel: 'Mağaza filtresi',
      categoryFilterLabel: 'Kategori filtresi',
      virtualStockFilterLabel: 'Sanal stok filtresi',
      typeFilterLabel: 'Ürün türü filtresi',
      statusFilterLabel: 'Durum filtresi',
      searchPlaceholder: 'Ürün veya mağaza ara…',
      searchLabel: 'Ürün veya mağaza ara',
      totalProducts: 'Toplam {total} ürün',
      showing: '{from}–{to} arası gösteriliyor',
      perPage: 'Sayfa başına',
      perPageLabel: 'Sayfa başına gösterilecek ürün sayısı',
      deleteConfirm: 'Bu mağaza fiyat kaydını silmek istediğinize emin misiniz?',
      deleteSuccess: 'Mağaza fiyatı silindi.',
      deleteFailed: 'Silinemedi',
    },

    commissions: {
      title: 'Pazaryeri Entegrasyonu',
      tabRules: 'Komisyon Kuralları',
      tabSync: 'Senkronizasyon',
      tabCalc: 'Hesaplama',
      allStores: 'Tüm mağazalar',
      newRule: 'Yeni Kural',
      editRuleTitle: 'Kural Düzenle',
      newRuleTitle: 'Yeni Komisyon Kuralı',
      ruleNameLabel: 'Kural Adı',
      ruleNamePlaceholder: 'Örn: Genel Komisyon',
      storeLabel: 'Mağaza',
      rateLabel: 'Oran (%)',
      fixedFeeLabel: 'Sabit Ücret (₺)',
      minFeeLabel: 'Min. Komisyon (₺)',
      maxFeeLabel: 'Maks. Komisyon (₺, 0=sınırsız)',
      noRules: 'Henüz komisyon kuralı yok.',
      colRuleName: 'Kural Adı',
      colStore: 'Mağaza',
      colCategory: 'Kategori',
      colRate: 'Oran',
      colFixed: 'Sabit',
      general: 'Genel',
      deleteRuleConfirm: '"{name}" silinsin mi?',
      testingConnection: 'Test ediliyor…',
      testConnection: 'Bağlantı Testi',
      pulling: 'Çekiliyor…',
      pullOrders: 'Siparişleri Çek',
      connectionError: 'Bağlantı hatası.',
      ordersCount: '{count} sipariş çekildi.',
      pullError: 'Sipariş çekme hatası.',
      calcTitle: 'Komisyon Hesaplama',
      salePriceLabel: 'Satış Fiyatı (₺)',
      calculating: 'Hesaplanıyor…',
      calcBtn: 'Hesapla',
      salePrice: 'Satış Fiyatı',
      commissionRow: 'Komisyon (%{rate})',
      netEarnings: 'Net Kazanç',
      selectStore: 'Seçin',
    },
  },

  // ── Invoices ──────────────────────────────────────────────────────────────
  invoices: {
    title: 'Faturalar',
    totalRecords: 'Toplam {count} kayıt',
    colInvoiceNo: 'Fatura No',
    colName: 'Ad Soyad',
    colTax: 'KDV',
    colIssuedAt: 'Düzenleme',
    colIntegrator: 'Entegratör',
    colPdf: 'PDF',
    pdfDownload: 'PDF indir',
  },

  // ── Tickets ───────────────────────────────────────────────────────────────
  tickets: {
    customerRequests: 'Müşteri Talepleri',
    orderBased: 'Sipariş Bazlı',
  },

  // ── Adverts ───────────────────────────────────────────────────────────────
  adverts: {
    title: 'İlan Yönetimi',
    advertCount: 'Toplam {count} ilan',
    tabList: 'İlanlar',
    tabCategories: 'Kategoriler',

    statusAll: 'Tümü',
    statusPending: 'Bekliyor',
    statusApproved: 'Onaylı',
    statusRejected: 'Reddedildi',
    statusSold: 'Satıldı',
    statusExpired: 'Süresi Doldu',

    colTitle: 'Başlık',
    colCategory: 'Kategori',
    colUser: 'Kullanıcı',
    colPrice: 'Fiyat',
    colStatus: 'Durum',
    colEndDate: 'Bitiş',
    colActions: 'İşlem',

    searchLabel: 'Arama',
    searchPlaceholder: 'İlan başlığı',
    statusLabel: 'Durum',
    categoryLabel: 'Kategori',

    approve: 'Onayla',
    reject: 'Reddet',
    delete: 'Sil',
    detail: 'Detay',
    loadError: 'İlan listesi alınamadı.',
    approveSuccess: 'İlan onaylandı ve yayına alındı.',
    approveFailed: 'İlan onaylanamadı.',
    rejectSuccess: 'İlan reddedildi.',
    rejectFailed: 'İlan reddedilemedi.',
    deleteSuccess: 'İlan silindi.',
    deleteFailed: 'İlan silinemedi.',

    // Reject modal
    rejectModalTitle: 'İlanı Reddet',
    rejectConfirmDesc: 'ilanını reddetmek istediğinize emin misiniz?',
    rejectReasonPlaceholder: 'Red sebebi (isteğe bağlı)',
    rejecting: 'Reddediliyor…',
    approveAndPublish: 'Onayla ve Yayınla',
    approving: 'Onaylanıyor…',

    // Categories tab
    newCategory: 'Yeni Kategori',
    noCategoriesYet: 'Henüz kategori yok.',
    categoryNameLabel: 'Ad',
    cloneSuccess: 'Kategori kopyalandı.',
    cloneFailed: 'Kategori kopyalanamadı.',
    categoryDeleteSuccess: 'Kategori silindi.',
    categoryDeleteFailed: 'Kategori silinemedi.',

    // AdvertRulesPage
    rulesPageTitle: 'İlan Kuralları',
    allCategoriesFilter: 'Tüm Kategoriler',
    newRuleButton: 'Yeni Kural',
    colType: 'Tür',
    colOrder: 'Sıra',
    ruleNotFound: 'Kural bulunamadı.',
    ruleSaved: 'Kaydedildi.',
    ruleDeleted: 'Silindi.',
    ruleDeleteFailed: 'Silinemedi.',
    ruleDeleteConfirm: 'Silinsin mi?',
    ruleEditTitle: 'Kural Düzenle',
    ruleNewTitle: 'Yeni Kural',
    ruleFormCategory: 'Kategori',
    ruleFormType: 'Tür',
    ruleTypeInfo: 'Bilgi',
    ruleTypeWarning: 'Uyarı',
    ruleTypeRule: 'Kural',
    ruleTypeSuccess: 'Olumlu',
    ruleTypeDanger: 'Yasak',
    ruleTypeTip: 'İpucu',
    ruleTypeNotice: 'Duyuru',
    ruleTypeSeller: 'Satıcı',
    ruleTypeBuyer: 'Alıcı',
    ruleFormOrder: 'Sıra',
    ruleFormTitle: 'Başlık *',
    ruleFormWarning: 'Uyarı Metni',
    ruleFormRules: 'Kural Metni',
    ruleFormActive: 'Aktif',

    // AdvertCommentsPage
    commentsTitle: 'Satıcı / Ürün Yorumları',
    commentSearchPlaceholder: 'Ürün veya kullanıcı ara…',
    noComments: 'Yorum bulunamadı.',
    productLabel: 'Ürün:',
    commentApproveSuccess: 'Onaylandı.',
    commentRejectSuccess: 'Reddedildi.',
    commentDeleteSuccess: 'Silindi.',
    commentDeleteFailed: 'Silinemedi.',
    rejectedApproveQ: 'Reddedildi — Onayla?',
    showMore: 'Tamamını göster',
    showLess: 'Daha az',
    commentDeleteConfirm: 'Silmek istediğinizden emin misiniz?',

    // AdvertCategoryFormPage
    catBackLink: 'Kategori Listesi',
    catEditTitle: 'İlan Kategorisi Düzenle',
    catNewTitle: 'İlan Kategorisi Ekle',
    catClone: 'Kopyala',
    catCreate: 'Oluştur',
    catSaving: 'Kaydediliyor…',
    catSaveSuccess: 'Kategori güncellendi.',
    catCreateSuccess: 'Kategori oluşturuldu.',
    catSaveFailed: 'Kayıt başarısız.',
    catNameRequired: 'Kategori adı zorunludur.',
    catUploadFailed: 'Görsel yüklenemedi.',
    catClearFailed: 'Görsel silinemedi.',
    noImage: 'Resim Yok',
    sectionBasicInfo: 'Temel Bilgiler',
    sectionPricing: 'Fiyat ve Limit Ayarları',
    sectionDeliveryOpts: 'Teslimat Seçenekleri',
    sectionDescriptions: 'Açıklamalar',
    sectionCreateFields: 'İlan Açarken İstenen Bilgiler',
    sectionDeliveryFields: 'Teslimatta İstenen Bilgiler',
    sectionBuyerFields: 'Alıcıdan İstenen Bilgiler',
    addField: 'Alan Ekle',
    deliveryAdd: 'Ekle',
    noDeliveryOptions: 'Henüz teslimat seçeneği yok.',
    fieldNumber: 'Alan #{index}',
    fieldInputType: 'Input Tipi',
    fieldFilterType: 'Filtre Tipi (İlan Pazarı)',
    fieldPlaceholder: 'Placeholder',
    fieldSortOrder: 'Sıralama',
    fieldSelectValues: 'Seçim Değerleri (her satır bir değer)',
    flagRequired: 'Zorunlu',
    flagShowInCard: 'Kartta Göster',
    labelCatName: 'Kategori Adı',
    labelSlug: 'Slug (URL)',
    labelListPreview: 'Liste Önizleme İsmi',
    labelParent: 'Üst Kategori',
    labelRootCategory: 'Kök kategori',
    labelRegion: 'Hizmet Bölgesi',
    labelAllRegions: 'Tüm Bölgeler',
    labelSimilar: 'Benzer Kategori',
    labelSelectOption: 'Seçiniz',
    switchPublicChat: 'Açık Mesajlaşma',
    switchLimitedStock: 'Adetli Satış',
    switchUnlimitedStock: 'Limitsiz Stok',
    switchModerator: 'Moderatör Onayı',
    labelMinPrice: 'Min. Fiyat (₺)',
    labelMaxPrice: 'Max. Fiyat (₺)',
    labelSaleLimit: 'Satış Limiti',
    labelBuyLimit: 'Alış Limiti',
    labelCommission: 'Komisyon %',
    labelDuration: 'İlan Süresi (Gün)',
    catDescLabel: 'Kategori Açıklaması',
    catDescPlaceholder: 'Kategori açıklaması…',
    catHowToUseLabel: 'Nasıl Kullanılır?',
    catHowToUsePlaceholder: 'Kullanım talimatları…',
    catMetaChars: '{count}/160 karakter',
    imageCategoryLabel: 'Kategori Resmi',
    imageDefaultLabel: 'Varsayılan İlan Resmi',
    imagePreviewLabel: 'Kategori Önizleme Resmi',
    inputTypeText: 'Metin',
    inputTypeLongText: 'Uzun Metin',
    inputTypeNumber: 'Sayı',
    inputTypeSelect: 'Seçim',
    inputTypeCheckbox: 'Onay Kutusu',
    filterTypeNone: 'Filtre Yok',
  },

  // ── Coupons ───────────────────────────────────────────────────────────────
  coupons: {
    title: 'Kuponlar',
    total: 'Toplam {count}',
    newCoupon: 'İndirim kuponu oluştur',
    createTitle: 'Yeni kupon',
    bulkActions: 'Toplu kupon işlemleri',
    bulkActivate: 'Seçilenleri aktif et',
    bulkDeactivate: 'Seçilenleri pasif et',
    bulkDelete: 'Seçilenleri sil',
    statTotal: 'Toplam kupon',
    statActive: 'Aktif kupon',
    statUsage: 'Toplam kullanım',
    statMonth: 'Bu ay oluşturulan',
    colAmount: 'İnd. miktarı',
    colTip: 'Tip',
    colRestriction: 'Kısıtlama',
    colMin: 'Alt limit',
    colProductLimit: 'Ürn. limit',
    colCouponCount: 'Kupon sayısı',
    colUsed: 'Kul. sayısı',
    colKind: 'Tür',
    colDealer: 'Bayi kullanımı',
    colCart: 'Sepette öner',
    colHome: 'Anasayfada öner',
    colSalePrice: 'Ö. fiyat izni',
    colValidUntil: 'Geçerlilik tarihi',
    colCreated: 'Oluşturma tarihi',
    kindProduct: 'Ürün bazlı',
    kindGeneral: 'Genel',
    restrictionYes: 'Var',
    restrictionNo: 'Yok',
    unlimited: 'Limitsiz',
    dealerUsage: 'Bayi hesapları kullanabilsin',
    suggestCart: 'Sepette öner',
    suggestHome: 'Anasayfada öner',
    allowSalePrice: 'Özel fiyatlı ürünlerde geçerli',
    productQtyLimit: 'Ürün adet limiti',
    editCoupon: 'Kupon düzenle',
    backAriaLabel: 'Kupon listesine dön',
    invalidId: 'Geçersiz kupon.',
    loadError: 'Kupon yüklenemedi.',
    saveFailed: 'Kayıt başarısız.',
    pageInfo: 'Sayfa {current}/{last}',

    searchPlaceholder: 'Kod veya açıklama',
    showExpired: 'Süresi dolmuşları göster',

    colCode: 'Kod',
    colClass: 'Sınıf',
    colTypeValue: 'Tip / Değer',
    colUsage: 'Kullanım',
    noCoupons: 'Kupon yok.',
    deleteConfirm: '"{code}" kuponunu silmek istediğinizden emin misiniz?',
    statusToggleFailed: 'Durum değiştirilemedi.',

    codeLabel: 'Kupon kodu',
    codeHint: 'Kod kayıt sonrası değişmez. Yeni bir kod için yeni kupon açın.',
    classLabel: 'Ne kazandırır',
    classDiscount: 'Sepet indirimi',
    classSpin: 'Çark hakkı',
    classPoint: 'Puan',
    discountTypeLabel: 'İndirim tipi',
    typePercentage: 'Yüzde',
    typeFixed: 'Sabit tutar',
    typeFreeShipping: 'Ücretsiz kargo',
    valueLabel: 'Değer',
    valueFreeShippingHint: 'Ücretsiz kargoda tutar yazılmaz',
    maxDiscountLabel: 'İndirim tavanı',
    minOrderLabel: 'Alt limit',
    usageLimitLabel: 'Toplam kullanım',
    perUserLimitLabel: 'Kişi başı kullanım',
    startLabel: 'Başlangıç',
    endLabel: 'Bitiş',
    requiresPhone: 'Telefon doğrulaması',
    requiresEmail: 'E-posta doğrulaması',
    firstOrderOnly: 'Yalnızca ilk sipariş',
    sectionType: 'Kupon tipi',
    sectionTypeHint: 'Müşteri bu kodu kullanınca ne kazanacağını seçin.',
    sectionBasics: 'Temel bilgiler',
    sectionBasicsHint: 'Kod, açıklama ve kuponun geçerli olduğu tarih aralığı.',
    sectionLimits: 'Limitler',
    sectionLimitsHint: 'Boş bıraktığınız sınır uygulanmaz.',
    sectionDates: 'Geçerlilik',
    sectionDatesHint: 'Tarih boşsa kupon hemen başlar veya süresiz kalır.',
    sectionAudience: 'Kim kullanabilir',
    sectionAudienceHint: 'Ek şart istemiyorsanız anahtarları kapalı bırakın.',
    sectionVisibility: 'Nerede görünsün',
    sectionVisibilityHint: 'Açık olan kupon ödeme adımında hazır seçenek olarak durur.',
    infoCode: 'Müşteri bu kodu sepette yazar. Harf, rakam ve tire kullanın. Kayıttan sonra kod değişmez.',
    infoClass: 'Sepet indirimi tutarı düşürür. Çark hakkı ekstra çevirme ekler. Puan, sadakat bakiyesine yüklenir.',
    infoType: 'Yüzde sepetin bir kısmını, sabit tutar belirli bir parayı düşer. Ücretsiz kargo yalnızca kargo ücretini sıfırlar.',
    infoValue: 'Yüzde için 10 yazarsanız sepetten yüzde 10 düşer. Sabit tutarda 50, elli lira indirim demektir.',
    infoMax: 'Yüzde indirimin geçemeyeceği en yüksek tutar. Örneğin yüzde 20 en fazla 100 lira olsun istiyorsanız 100 yazın.',
    infoMin: 'Sepet bu tutarın altındaysa kod kabul edilmez. Boş bırakırsanız alt sınır olmaz.',
    infoUsage: 'Kod mağazada toplam kaç kez kullanılabilir. Boşsa sınırsızdır.',
    infoPerUser: 'Aynı müşteri bu kodu en fazla kaç kez kullanabilir.',
    infoQty: 'Sepetteki toplam adet bu sayıyı aşarsa kod geçersiz olur. Boşsa adet sınırı yoktur.',
    infoStart: 'Bu tarihten önce kod çalışmaz. Boşsa hemen geçerlidir.',
    infoEnd: 'Bu tarihten sonra kod kapanır. Boşsa süresi dolmaz.',
    infoPhone: 'Yalnızca telefonunu doğrulamış müşteriler kullanabilir.',
    infoEmail: 'Yalnızca e-postasını doğrulamış müşteriler kullanabilir.',
    infoFirst: 'Daha önce tamamlanmış siparişi olan müşteri bu kodu kullanamaz.',
    infoDealer: 'Açıksa satıcı hesapları da kullanabilir. Kapalıysa yalnızca normal müşteri kullanır.',
    infoCart: 'Açıksa kod, ödeme sayfasında hazır düğme olarak görünür.',
    infoHome: 'Açıksa kod anasayfa önerilerine alınır.',
    infoSale: 'Kapalıysa piyasa fiyatının altında satılan ürünlerde kod reddedilir.',
    infoActive: 'Kapalı kupon sepette kabul edilmez.',
    saving: 'Kaydediliyor…',
    createSuccess: 'Kupon oluşturuldu.',
    updateSuccess: 'Kupon güncellendi.',
    valueError: 'Değer alanını kontrol edin.',
    codeRequired: 'Kupon kodu gerekli.',
  },

  // ── Expenses ──────────────────────────────────────────────────────────────
  expenses: {
    title: 'Gider Yönetimi',
    description: 'Mağaza giderlerini takip edin ve raporlayın',
    addExpense: 'Gider Ekle',
    totalExpense: 'Toplam Gider',
    paidAmount: 'Ödenen',
    pendingAmount: 'Bekleyen',
    noExpensesTitle: 'Henüz gider kaydı yok',
    noExpensesDesc: 'İlk gider kaydınızı ekleyerek finansal takibi başlatın.',

    colTitle: 'Başlık',
    colCategory: 'Kategori',
    colAmount: 'Tutar',
    colDate: 'Tarih',
    colStatus: 'Durum',

    statusPending: 'Bekliyor',
    statusPaid: 'Ödendi',
    statusCancelled: 'İptal',
    methodCash: 'Nakit',
    methodBank: 'Banka',
    methodCard: 'Kart',
    methodOther: 'Diğer',

    editExpense: 'Gider Düzenle',
    newExpense: 'Yeni Gider',
    titleLabel: 'Başlık *',
    categoryLabel: 'Kategori',
    amountLabel: 'Tutar (₺) *',
    paymentDateLabel: 'Ödeme Tarihi *',
    statusLabel: 'Durum',
    methodLabel: 'Yöntem',
    deleteConfirm: 'Gider silinsin mi?',
    deleteSuccess: 'Gider silindi.',
    deleteFailed: 'Gider silinemedi.',
  },

  // ── Points ────────────────────────────────────────────────────────────────
  points: {
    title: 'Puan & Ödül Sistemi',
    tabTransactions: 'İşlem Geçmişi',
    tabAdjust: 'Manuel Puan',
    tabConfig: 'Ayarlar',

    typeAll: 'Tümü',
    typeEarn: 'Kazanıldı',
    typeSpend: 'Harcandı',
    typeExpire: 'Süresi Doldu',
    typeAdminAdjust: 'Admin Ayarı',

    colUser: 'Kullanıcı',
    colType: 'Tip',
    colAmount: 'Miktar',
    colBalance: 'Bakiye',
    colDesc: 'Açıklama',
    colDate: 'Tarih',
    noTransactions: 'İşlem bulunamadı.',

    adjustDesc: 'Bir kullanıcıya manuel puan eklemek veya çıkarmak için ID girin.',
    userIdLabel: 'Kullanıcı ID *',
    amountLabel: 'Puan Miktarı * (eklemek için +, çıkarmak için -)',
    amountPlaceholder: '100 veya -50',
    adjustDescLabel: 'Açıklama *',
    descPlaceholder: 'Kampanya bonusu, hata düzeltme…',
    applying: 'Uygulanıyor…',
    applyButton: 'Puan Ayarını Uygula',
    adjustSuccess: 'Puan ayarı başarıyla uygulandı.',
    adjustError: 'Hata oluştu.',

    configDesc: 'Puan kuralları',
    configFileDesc: 've',
    configFileDesc2: 'üzerinden yönetilir.',
    earnRateTitle: 'Kazanma',
    earnRateField: 'Puan kazanma oranı (%)',
    earnRateInfo: 'Sipariş tutarının yüzde kaçı puan olur. 5 yazarsanız 100 liralık sipariş 5 puan kazandırır. Boş bırakırsanız sunucu varsayılanı kullanılır. 0 puan kazandırmaz.',
    earnRatePlaceholder: 'Örn. 5',
    earnRateSaved: 'Puan kazanma oranı kaydedildi.',
    earnRateSaveFailed: 'Puan kazanma oranı kaydedilemedi.',
    earnRateLabel: 'Kazanma oranı (1 TL = ? puan)',
    minOrderLabel: 'Minimum sipariş tutarı',
    spendRateLabel: 'Harcama oranı (1 puan = ? TL)',
    maxSpendRatioLabel: 'Maks. puan kullanım oranı',
    backendHint: 'Değiştirmek için backend',
    backendFileHint: 'dosyasına ekleyin:',
  },

  // ── Wheel ─────────────────────────────────────────────────────────────────
  wheel: {
    title: 'Şans Çarkı',
    addSegment: 'Dilim Ekle',
    tabSegments: 'Dilimler',
    tabPrizes: 'Ödüller',
    totalProbWarning: 'Toplam olasılık: {total}% (100% olmalı)',

    colColor: 'Renk',
    colLabel: 'Etiket',
    colProbability: 'Olasılık',
    colReward: 'Ödül',
    colValue: 'Değer',
    colActive: 'Aktif',
    colActions: 'İşlem',
    noSegments: 'Dilim yok. "Dilim Ekle" ile başlayın.',

    colUser: 'Kullanıcı',
    colRewardType: 'Ödül Türü',
    colUsed: 'Kullanıldı',
    noPrizes: 'Ödül kaydı yok.',
    redeemed: 'Kullanıldı',
    notRedeemed: 'Bekliyor',

    editSegment: 'Dilim Düzenle',
    newSegment: 'Yeni Dilim',
    labelLabel: 'Etiket *',
    colorLabel: 'Renk',
    probabilityLabel: 'Olasılık (%)',
    orderLabel: 'Sıra',
    rewardTypeLabel: 'Ödül Türü',
    valueLabel: 'Değer',

    typePoints: 'Puan',
    typeFreeSpin: 'Ücretsiz Çevirme',
    typeDiscount: 'İndirim',
    typeFreeProduct: 'Ücretsiz Ürün',
    deleteConfirm: 'Silinsin mi?',
    saving: 'Kaydediliyor…',
    saved: 'Kaydedildi.',
    deleted: 'Silindi.',
    colDate: 'Tarih',
  },

  // ── Dashboard ─────────────────────────────────────────────────────────────
  dashboard: {
    title: 'Dashboard',
    description: 'Mağazanızın genel performans özeti',
    loadError: 'Özet verileri alınamadı. Oturum ve mağaza alan adını kontrol edin.',

    totalRevenue: 'Toplam Ciro',
    thisMonthRevenue: 'Bu Ay Gelir',
    totalOrders: 'Toplam Sipariş',
    completedOrders: 'Tamamlanan',
    totalOrdersFrom: '{completed} toplam siparişten',
    unitLabel: 'Adet',

    daily: 'Günlük',
    weekly: 'Haftalık',
    monthly: 'Aylık',

    totalSales: 'Toplam Satış',
    totalIncome: 'Toplam Gelir',
    avgOrder: 'Ort. Sipariş',
    monthlyGrowth: 'Aylık Büyüme',
    comparedToLastMonth: 'Geçen aya göre',

    salesAnalysis: 'Satış Analizi',
    salesAnalysisDesc: 'Tüm satış verilerinin detaylı analizi',
    chartTotalOrders: 'Toplam Sipariş',
    chartCompleted: 'Tamamlanan',
    chartRevenue: 'Gelir (₺)',

    topCategories: 'En Çok Satan Kategoriler',
    topCategoriesDesc: 'Bu ay satış performansı',
    noOrdersThisMonth: 'Bu ay henüz sipariş yok.',
    colCategory: 'Kategori',
    colSales: 'Satış',
    colRevenue: 'Gelir',
    colTrend: 'Trend',

    ordersPanel: 'Siparişler',
    todayNew: 'Bugün: {count} Yeni',
    totalLabel: 'Toplam',
    pendingLabel: 'Bekleyen',
    doneLabel: 'Tamam',

    orderStatusCompleted: 'Tamamlandı',
    orderStatusProcessing: 'İşlemde',
    orderStatusShipped: 'Kargoda',
    orderStatusPending: 'Yeni',
    orderStatusCancelled: 'İptal',
    orderStatusRefunded: 'İade',

    viewAllOrders: 'Tüm Siparişleri Görüntüle',
    viewAllCustomers: 'Tüm Müşterileri Görüntüle',

    topCustomersTitle: 'Son 7 Gün',
    topCustomersDesc: 'En çok harcayan müşteriler',
    live: 'Canlı',
    noData: 'Veri yok.',

    activeProducts: 'Aktif Ürün',
    customers: 'Müşteri',
    weekOrders: 'Bu Hafta Sipariş',
    newCustomers7d: 'Yeni Müşteri (7g)',

    orderStatuses: 'Sipariş Durumları',
    completionRate: 'Tamamlanma Oranı',
    decrease: 'düşüş',
    noPeriodData: 'Bu dönemde veri yok.',

    topProducts: 'En Çok Satan Ürünler',
    noSalesData: 'Bu dönemde satış verisi yok.',
    colProduct: 'Ürün',
    colQty: 'Satış Adedi',
  },

  // ── Reports ───────────────────────────────────────────────────────────────
  reports: {
    filterStart: 'Başlangıç',
    filterEnd: 'Bitiş',
    filterButton: 'Filtrele',
    loadError: 'Rapor verileri alınamadı.',

    netRevenue: 'Net Gelir',
    grossPrefix: 'Brüt:',
    totalOrders: 'Toplam Sipariş',
    completedSuffix: 'tamamlandı',
    orderSuffix: 'sipariş',
    refunds: 'İade',
    newCustomers: 'Yeni Müşteri',
    thisPeriod: 'Bu dönemde',

    trendTitle: 'Gelir ve Sipariş Trendi',
    noTrendData: 'Bu dönemde veri yok.',
    orderBarName: 'Sipariş',
    completedBarName: 'Tamamlanan',
    revenueLineName: 'Gelir (₺)',

    orderStatuses: 'Sipariş Durumları',
    completionRate: 'Tamamlanma Oranı',
    statusCompleted: 'Tamamlandı',
    statusPending: 'Bekliyor',
    statusProcessing: 'İşlemde',
    statusShipped: 'Kargoda',
    statusCancelled: 'İptal',
    statusRefunded: 'İade',

    topProductsTitle: 'En Çok Satan Ürünler',
    noTopProducts: 'Bu dönemde satış verisi yok.',
    colRank: '#',
    colProduct: 'Ürün',
    colQty: 'Satış Adedi',
    colRevenue: 'Gelir',
    colTrend: 'Trend',

    // Stock reports
    stockTitle: 'Stok Raporları',
    totalStocks: 'Toplam {count} stok kalemi',
    filterAll: 'Tüm Stoklar',
    filterLow: 'Kritik Seviye',
    filterOut: 'Tükenen Stoklar',
    attention: 'Dikkat',
    stockLoadError: 'Stok verileri alınamadı.',
    colVariant: 'Varyant',
    colProductCode: 'Ürün Kodu',
    colSalePrice: 'Satış Fiyatı',
    colCostLabel: 'Maliyet',
    colCurrency: 'Para Birimi',
    noLowStock: 'Kritik seviyede stok yok.',
    noOutStock: 'Tükenen stok yok.',
    noStock: 'Stok bulunamadı.',

    // Member reports
    memberTitle: 'Üye Raporları',
    totalMembers: 'Toplam {count} üye',
    kpiTotalMembers: 'Toplam Üye',
    kpiActive: 'Aktif',
    kpiInactiveSuspended: 'Pasif / Askıda',
    kpiWithBalance: 'Bakiyeli',
    accountStatus: 'Hesap Durumu:',
    memberLoadError: 'Üye verileri alınamadı.',
    colEmail: 'E-posta',
    colFullName: 'Ad Soyad',
    colBalance: 'Bakiye',
    colRegistered: 'Kayıt Tarihi',
    noMembers: 'Üye bulunamadı.',
    memberStatusActive: 'Aktif',
    memberStatusInactive: 'Pasif',
    memberStatusSuspended: 'Askıda',
    allMemberStatuses: 'Tüm durumlar',
  },

  // ── Analytics ─────────────────────────────────────────────────────────────
  analytics: {
    title: 'Analitik',
    tabOverview: 'Genel Bakış',
    tabCohort: 'Kohort',
    tabFunnel: 'Dönüşüm Hunisi',
    loadError: 'Veri yüklenemedi.',

    totalViews: 'Toplam Görüntüleme',
    uniqueVisitors: 'Tekil Ziyaretçi',
    topSearch: 'Top Arama',
    topProduct: 'Top Ürün',

    dailyViewsTitle: 'Günlük Sayfa Görüntüleme',
    deviceTitle: 'Cihaz Dağılımı',
    browserTitle: 'Tarayıcı Dağılımı',
    topSearchesTitle: 'En Çok Arananlar',
    topPagesTitle: 'En Çok Ziyaret Edilen Sayfalar',
    topProductsTitle: 'En Çok Görüntülenen Ürünler',

    colRank: '#',
    colPage: 'Sayfa',
    colViews: 'Görüntüleme',
    colProduct: 'Ürün',
    colOrders: 'Sipariş',
    colRevenue: 'Gelir',

    mobile: 'Mobil',
    tablet: 'Tablet',
    desktop: 'Masaüstü',
    noData: 'Veri yok',

    cohortTitle: 'Kullanıcı Retention Kohortu',
    cohortDesc: 'İlk sipariş ayına göre gruplar; sonraki aylarda tekrar sipariş veren kullanıcı oranı',
    monthsLabel: 'Ay sayısı:',
    cohortHeader: 'Kohort',
    cohortSize: 'Boyut',
    month0: 'Ay 0',
    noOrderData: 'Seçilen dönemde sipariş verisi bulunamadı.',

    funnelTitle: 'Satış Dönüşüm Hunisi',
    funnelDesc: 'Ziyaretçiden tamamlanan ödemeye adım adım dönüşüm oranı',
    funnelChartTitle: 'Adım Başına Kullanıcı Sayısı',
    userAxisLabel: 'Kullanıcı',
    percentTotal: '{rate}% toplam',
    dropRate: '−{rate}% düşüş',
  },
}

// ─── English ─────────────────────────────────────────────────────────────────

export const en: Dictionary = {
  orders: {
    title: 'Orders',
    searchPlaceholder: 'Order no, email, name, phone…',
    filtersToggle: 'Toggle filters',
    clearFilters: 'Clear filters',
    orderCount: '{count} orders',
    pageInfo: 'Page {current}/{last}',

    colAmount: 'Amount',
    colPayment: 'Payment',
    colDelivery: 'Delivery',
    unitLabel: 'Unit:',
    itemCount: '{count} item(s)',
    transferPayment: 'Bank Transfer',

    statusAll: 'All',
    statusPending: 'Pending',
    statusProcessing: 'Processing',
    statusShipped: 'Shipped',
    statusDelivered: 'Delivered',
    statusCompleted: 'Completed',
    statusCancelled: 'Cancelled',
    statusRefunded: 'Refunded',

    paymentPending: 'Awaiting payment',
    paymentPaid: 'Paid',
    paymentFailed: 'Failed',
    paymentPartialRefunded: 'Partially refunded',

    fraudAll: 'All',
    fraudNotRequired: 'Not required',
    fraudPendingReview: 'Under review',
    fraudApproved: 'Approved',
    fraudDeclined: 'Declined',

    smartCancelled: 'Cancelled',
    smartRefunded: 'Refunded',
    smartShipped: 'Shipped',
    smartDelivered: 'Delivered',
    smartProcessing: 'Processing',
    smartDeliveryPending: 'Awaiting delivery',
    smartPaymentPending: 'Awaiting payment',

    paymentTypeBalance: 'Balance',
    paymentTypeTransfer: 'Bank Transfer',
    paymentTypeCard: 'Card',

    loadError: 'Failed to load orders.',
    notFoundTitle: 'No orders found',
    noMatchDescription: 'No records match the current filters.',
    openDetail: 'Open detail',

    startDate: 'Start date',
    endDate: 'End date',

    backToList: 'Back to orders',
    orderTitle: 'Order {number}',
    detailTitle: 'Order Detail',
    downloadPdfAriaLabel: 'Download order details PDF',
    pdfDownloaded: 'Order details PDF downloaded.',
    pdfFailed: 'Failed to generate PDF.',
    detailPdf: 'Detail PDF',

    summarySection: 'Summary',
    paymentLabel: 'Payment:',
    fraudLabel: 'Fraud:',
    createdAtLabel: 'Created:',
    customerNameLabel: 'Name',
    customerAccount: 'Account',
    itemsSection: 'Items',
    unitPriceLabel: 'Unit',
    lineTotalLabel: 'Line',
    paymentsSection: 'Payments',
    paymentCount: 'payment(s)',
    approveTransfer: 'Approve Transfer',
    reject: 'Reject',
    approve: 'Approve',
    updateStatus: 'Update status',
    orderStatusLabel: 'Order status *',
    cancelReasonLabel: 'Cancel / note reason',
    cargoProvider: 'Cargo provider',
    trackingNumber: 'Tracking number',
    fraudStatusLabel: 'Fraud status',
    fraudKeepCurrent: 'Keep current',
    saving: 'Saving…',
    saveStatus: 'Save status',
    liveTracking: 'Live cargo tracking',
    lastStatus: 'Last status:',
    selectIntegration: 'Select integration…',
    trackingFailed: 'Cargo tracking failed.',
    querying: 'Querying…',
    query: 'Query',
    statusHistory: 'Status history',
    activityLog: 'Log',
    refundSection: 'Refund',
    refundAmountLabel: 'Refund amount',
    refundFullHint: 'empty = full refund',
    reason: 'Reason',
    processing: 'Processing…',
    startRefund: 'Start refund',

    statusUpdated: 'Order status updated.',
    refundSuccess: 'Refund successful',
    transferApproved: 'Transfer approved — order queued for processing',
    transferRejected: 'Transfer payment rejected',
    transferActionFailed: 'Transfer approve/reject failed.',
    invalidOrder: 'Invalid order.',
    loadDetailError: 'Failed to load order.',

    fullPage: 'Full page',
    openFullPage: 'Open full page',
    paid: 'Paid',
    tabOverview: 'Overview',
    tabFinancial: 'Financial',
    tabManage: 'Manage',
    tabHistory: 'History',
    customerFullName: 'Full name',
    tcNo: 'ID No',
    company: 'Company',
    taxNumber: 'Tax no',
    deliveryAddress: 'Delivery address',
    fraudReason: 'Fraud reason',
    cancelReason: 'Cancel reason',
    coupon: 'Coupon',
    source: 'Source',
    externalNo: 'External no',
    ipAddress: 'IP',
    cargoFirm: 'Cargo firm',
    trackingNo: 'Tracking no',
    cargoStatusLabel: 'Cargo status',
    noMeta: 'No extra order meta.',
    billingInfo: 'Billing information',
    billingName: 'Title / Name',
    taxOffice: 'Tax office',
    billingAddress: 'Billing address',
    grossRevenue: 'Revenue',
    cost: 'Cost',
    netProfit: 'Net profit',
    margin: 'Margin',
    noPaymentRecord: 'No payment records.',
    amountLabel: 'Amount:',
    commissionLabel: 'Fee:',
    paymentDateLabel: 'Date:',
    cardLabel: 'Card:',
    bankLabel: 'Bank:',
    transferSender: 'Transfer:',
    pendingTransferNotice: 'Pending transfer notification — order will be queued after approval.',
    costSummary: 'Cost summary',
    grossSales: 'Product sales',
    itemDiscount: 'Item discount',
    netRevenue: 'Net revenue',
    productCost: 'Product cost',
    costLabel: 'Cost',
    showCosts: 'Show costs',
    hideCosts: 'Hide costs',
    costHint: 'Click the "Cost" button above to view cost/profit breakdown',
    statusCargoFraud: 'Status / cargo / fraud',
    cargoFirmLabel: 'Cargo company',
    cancelReasonNote: 'Cancel / note reason',
    cargoPlaceholder: 'Domestic, FedEx…',
    trackingPlaceholder: 'Tracking no',
    noHistory: 'No history yet.',

    deliveryAddressLabel: 'Delivery address',
    billingAddressLabel: 'Billing address',

    requestedFields: 'Requested fields',
    deliverySection: 'Delivery',
    processedAt: 'Processed',
    deliveredAt: 'Delivered',
    deliveredBy: 'Delivered by',
    cargoTrackLabel: 'Cargo tracking',
    notYetDelivered: 'Not yet delivered',
    cancelItemReason: 'Cancelled:',

    pendingDeliveryTitle: 'Pending Delivery',
    pendingDeliveryToggle: 'Toggle pending delivery section',
    pendingDeliveryError: 'Failed to load delivery queue.',
    noPendingItems: 'No items awaiting delivery.',
    deliveryNotePlaceholder: 'Delivery note…',
    deliveryNoteLabel: 'Delivery note',
    openOrderDetail: 'Open order detail',
    epinStockTitle: 'Add e-pin stock',
    epinInstructions: 'Enter at least {qty} code(s) (one per line). Added codes are saved and the item is delivered automatically.',
    epinCodesLabel: 'E-pin codes',
    epinAdded: 'E-pin added and delivered.',
    stockAddFailed: 'Failed to add stock.',
    addAndDeliver: 'Add and deliver',
    stockBadge: 'Stock',
    take: 'Take',
    release: 'Release',
    deliver: 'Deliver',
    locked: 'Locked',
    takeAction: 'Take',
    releaseAction: 'Release',
    deliverAction: 'Deliver',
    itemTaken: 'Item taken.',
    itemTakeFailed: 'Could not take item.',
    itemReleased: 'Item released.',
    itemReleaseFailed: 'Could not release item.',
    deliveredDot: 'Delivered.',
    deliverFailed: 'Delivery failed.',
    itemsTaken: 'Items taken.',
    itemsDelivered: 'Items delivered.',
    lockedBy: 'Locked · {user}',

    cancelledBadge: 'Cancelled',
    deliveredBadge: 'Delivered',
    transferApprovalLabel: 'Transfer approval',
    noPayment: 'No payment',
    paidBadge: 'Paid',
    approveTransferAriaLabel: 'Approve transfer',
    rejectTransferAriaLabel: 'Reject transfer',
    cancelOrderAriaLabel: 'Cancel order',
    cancelAction: 'Cancel',
    takeRemaining: 'Take remaining items',
    myItems: '{mine}/{total} with you',
    lockedItems: '{count} lock(s)',

    cancelModalTitle: 'Cancel Order',
    cancelRefundWarning: 'Payments for this order will also be cancelled/refunded!',
    cancelNoPaymentWarning: 'The order will be cancelled with no payment.',
    refundMethodTitle: 'Refund Method',
    refundMethodSubtitle: 'Choose how payments will be refunded',
    refundToBalance: 'Refund to Balance',
    refundToBalanceDesc: 'Payment amount will be added to the customer\'s account balance',
    refundToCard: 'Refund to Card',
    refundToCardDesc: 'Payment will be returned to the original card',
    cancelOnly: 'Cancel Only',
    cancelOnlyDesc: 'Payment is fully cancelled with no refund',
    cancelReasonTitle: 'Cancel reason',
    cancelReasonPlaceholder: 'Select cancel reason...',
    cancelReasonOther: 'Other (add description)',
    otherReasonPlaceholder: 'Type cancel reason…',
    otherReasonLabel: 'Other cancel reason',
    cancelReasonRequired: 'A cancel reason must be selected.',
    otherReasonRequired: 'Please provide a description for the other reason.',
    cancelSuccess: 'Order cancelled.',
    cancelFailed: 'Failed to cancel order.',
    cancelOrderButton: 'Cancel Order',
  },

  payments: {
    notifTitle: 'Payment Notifications',
    notifDescription: 'Review, approve or reject bank transfer notifications. Track all payment transactions in the other tab.',
    tabTransfer: 'Transfer approvals',
    tabAll: 'All payments',

    allStatuses: 'All statuses',
    statusAwaitingApproval: 'Awaiting approval',
    statusApproved: 'Approved',
    statusRejected: 'Rejected',
    statusPending: 'Pending',
    statusCompleted: 'Completed',
    statusFailed: 'Failed',
    statusRefunded: 'Refunded',
    statusCancelled: 'Cancelled',

    allTypes: 'All types',
    typeTransfer: 'Bank Transfer',
    typeBalance: 'Balance',
    typeIyzico: 'Iyzico',
    typePaytr: 'PayTR',
    typeStripe: 'Stripe',
    typePapara: 'Papara',
    typeVallet: 'Vallet',
    typeManual: 'Manual',

    filterSearchPlaceholder: 'Order / Name / Phone / Note',
    filterSearchAriaLabel: 'Search payments',
    filterStatusAriaLabel: 'Status filter',
    filterTypeAriaLabel: 'Payment type filter',
    filterButton: 'Filter',

    colOrder: 'Order',
    colSender: 'Sender',
    colBank: 'Bank',
    colBankAccount: 'Bank account',
    colDates: 'Dates',
    colNoteReceipt: 'Note / Receipt',
    colStatus: 'Status',
    colActions: 'Actions',
    colType: 'Payment type',
    colAmount: 'Amount',
    colPaymentDate: 'Payment',
    colNotifDate: 'Notification',
    colDecont: 'Receipt',

    colId: '#ID',
    colRefund: 'Refund',
    colDate: 'Date',
    colCustomer: 'Customer',

    approve: 'Approve',
    reject: 'Reject',
    openReceipt: 'Open receipt',

    detailTitle: 'Notification detail',
    clickRowHint: 'Click a row to see details',
    clickRowSubHint: 'Sender, IBAN, ID and note will appear here.',
    amountLabel: 'Amount',
    senderLabel: 'Sender',
    tcLabel: 'ID No',
    paymentDateDetail: 'Payment date',
    bankAccountLabel: 'Bank account',
    ibanCopy: 'Copy IBAN',

    approvedSuccess: 'Transfer approved — order queued for processing',
    rejectedSuccess: 'Notification rejected',
    statusUpdated: 'Status updated',
    actionFailed: 'Action failed',
    noPendingNotif: 'No pending transfer notifications. If there are pending transfers in Orders, they will appear here after a page refresh.',
    noPaymentRecords: 'No payment records found.',

    transactionsTitle: 'Payment Transactions',
    totalRecords: 'Total {count} records',

    balanceTitle: 'Balance Withdrawals',
    totalRequests: 'Total {count} requests',
    transactionCodeLabel: 'Transaction code',
    transactionCodePlaceholder: 'Search transaction code…',
    noWithdrawals: 'No balance withdrawal requests found.',
    colTransactionCode: 'Transaction Code',
    colMethod: 'Method',
    colDescription: 'Description',

    // Transaction detail page
    detail: {
      invalidId: 'Invalid transaction ID.',
      loadFailed: 'Failed to load transaction.',
      backToList: 'Back to list',
      title: 'Payment Transaction #',
      infoTitle: 'Transaction Details',
      amountLabel: 'Amount',
      paymentType: 'Payment type',
      refundType: 'Refund type',
      commission: 'Commission',
      createdAt: 'Created',
      updatedAt: 'Updated',
      noteDesc: 'Note / Description',
      providerTitle: 'Payment Provider',
      providerName: 'Name',
      providerKey: 'Key',
      balanceTxTitle: 'Balance Transaction',
      refundTitle: 'Refund',
      refundAmount: 'Refund amount',
      refundAmountHint: '(leave empty for full refund: {amount})',
      refundReason: 'Reason',
      processing: 'Processing…',
      initiateRefund: 'Initiate refund',
      alreadyRefunded: 'This payment has already been refunded ({type}).',
      onlyCompletedRefundable: 'Only completed payments can be refunded.',
      balanceNotRefundable: 'Balance payments cannot be refunded from this screen.',
      orderRequiredForRefund: 'An order is required to issue a refund.',
      refundSuccess: 'Refund successful — {type} {amount}',
      fullRefund: 'Full refund',
      partialRefund: 'Partial refund',
      orderNotFound: 'Order not found.',
    },
  },

  fraud: {
    title: 'Suspicious Transactions',
    rulesTitle: 'Fraud rules',
    rulesDesc: 'Order amount and rate limits — suspicious transaction thresholds.',

    statusAll: 'All',
    statusPending: 'Pending',
    statusApproved: 'Approved',
    statusRejected: 'Rejected',

    colOrder: 'Order',
    colDocType: 'Document Type',
    colFile: 'File',
    colStatus: 'Status',
    colDate: 'Date',
    colActions: 'Actions',

    approve: 'Approve',
    reject: 'Reject',
    approveDocTitle: 'Approve Document',
    rejectDocTitle: 'Reject Document',
    reasonOptional: 'Reason (optional)',
    approveSuccess: 'Document approved.',
    rejectSuccess: 'Document rejected.',
    actionFailed: 'Action failed.',
    orderLabel: 'Order:',
  },

  marketplace: {
    title: 'Store List',
    commissionsTitle: 'Marketplace Integration',
    applicationsTitle: 'Store Applications',
    pricesTitle: 'Store Product Prices',
    pricesInfo: 'Double-click · multiple rows · bulk save · double-click again = cancel row · limits in modal',

    colStore: 'Store',
    colLevel: 'Level',
    colBalance: 'Balance',
    colPending: 'Pending',
    colStatus: 'Status',
    colActions: 'Actions',

    newStore: 'New Store',
    editStore: 'Edit Store',
    addProductToStore: 'Add Product to Store',
    totalCount: 'Total {count}',

    searchPlaceholder: 'Search…',
    allStoresFilter: 'All Stores',
    allCategoriesFilter: 'All Categories',
    allVirtualStocksFilter: 'All Virtual Stocks',
    unassignedVirtualStock: 'Unassigned Virtual Stock',
    allTypesFilter: 'All Types',
    apiProducts: 'API Products',
    virtualStockProducts: 'Virtual Stock Products',
    allStatusesFilter: 'All Statuses',
    productSearchPlaceholder: 'Search product or store…',
    pageSizeLabel: 'Per page',
    totalProducts: 'Total {count} products',
    rangeShowing: 'Showing {from}–{to}',

    storeNameLabel: 'Store Name *',
    descriptionLabel: 'Description',
    levelLabel: 'Level',
    paymentDayLabel: 'Payment Day',
    logoHint: 'Select logo (uploaded after save)',
    removeLogoSelection: 'Remove selection',
    onlyImageError: 'Only image files can be uploaded.',
    fileSizeError: 'File size cannot exceed 2 MB.',
    storeCreatedLogoFailed: 'Store created but logo upload failed. Try again from the edit screen.',
    storeSaved: 'Updated.',
    storeCreated: 'Created.',
    storeDeleted: 'Deleted.',
    storeDeleteFailed: 'Could not delete.',
    storeSaveFailed: 'Action failed.',

    tabRules: 'Commission Rules',
    tabSync: 'Synchronization',
    tabCalc: 'Calculator',
    allStores: 'All stores',
    newRule: 'New Rule',
    editRule: 'Edit Rule',
    newCommissionRule: 'New Commission Rule',
    ruleNameLabel: 'Rule Name',
    ruleNamePlaceholder: 'e.g. General Commission',
    storeSelectLabel: 'Store',
    rateLabel: 'Rate (%)',
    fixedFeeLabel: 'Fixed Fee (₺)',
    minCommLabel: 'Min. Commission (₺)',
    maxCommLabel: 'Max. Commission (₺, 0=unlimited)',
    saving: 'Saving…',
    noRulesYet: 'No commission rules yet.',
    colRuleName: 'Rule Name',
    colRate: 'Rate',
    colFixed: 'Fixed',
    colCategory: 'Category',
    colGeneral: 'General',

    connectionTest: 'Connection Test',
    testing: 'Testing…',
    pullOrders: 'Pull Orders',
    pulling: 'Pulling…',
    connectionError: 'Connection error.',
    pullFailed: 'Failed to pull orders.',

    calcTitle: 'Commission Calculator',
    salePriceLabel: 'Sale Price (₺)',
    calculate: 'Calculate',
    salesPrice: 'Sale Price',
    commission: 'Commission',
    netEarning: 'Net Earning',

    appStatusAll: 'All',
    appStatusPending: 'Pending',
    appStatusApproved: 'Approved',
    appStatusRejected: 'Rejected',
    colCompany: 'Company',
    colContact: 'Contact',
    colWeb: 'Web',
    colApplicationDate: 'Application Date',
    reviewLabel: 'Review',
    contactTitle: 'Contact person',
    taxIdLabel: 'Tax ID',
    applicationDescLabel: 'Application Description',
    reviewTitle: 'Evaluation',
    adminNoteLabel: 'Admin Note',
    adminNotePlaceholder: 'Optional note…',
    approveWithStore: 'Approve & Create Store',
    applicationApproved: 'Application approved.',
    applicationRejected: 'Application rejected.',
    applicationActionFailed: 'Action failed.',
    noApplications: 'No applications found.',

    priceDeleted: 'Store price deleted.',
    priceDeleteFailed: 'Could not delete.',
    priceDeleteConfirm: 'Are you sure you want to delete this store price record?',

    // Applications detail modal
    detailModalTitle: 'Application Detail',
    companyNameLabel: 'Company Name',
    approveLabel: 'Approve',
    rejectLabel: 'Reject',

    // Price table columns
    colId: '# (ID)',
    colCost: 'Cost',
    colSale: 'Sale',
    colDealer: 'Dealer',
    colBuy: 'Purchase',
    colMarket: 'Market',
    colBuySaleLimits: 'Buy/Sale Limits',
    colBuyMinMax: 'Buy Min/Max',
    colStockCount: 'Stock Count',
    colStockRequired: 'Stock Required',
    colApiSale: 'API Sale',
    colApiStock: 'API Stock',

    // Price table toggle feedback
    statusUpdated: 'Status updated.',
    buyStatusUpdated: 'Purchase status updated.',
    stockRequiredUpdated: 'Stock required updated.',
    apiSaleUpdated: 'API sale updated.',
    apiStockUpdated: 'API stock updated.',

    // Price table UI
    sortAria: 'Sort by {col}',
    viewProductAria: 'View product',
    noStockLabel: 'Out of stock',
    editingRows: '{count} rows editing',
    saveAll: 'Save All',
    cancelAll: 'Cancel All',
    physicalPrefix: 'Physical: ',
    apiPrefix: 'API: ',
    virtualPrefix: 'Virtual: ',
    priceTypeProduct: 'Product',
    priceTypeApiProduct: 'API Product',
    priceTypeVirtualStock: 'Virtual Stock',
    priceTypeSelectVirtualStock: 'Select Virtual Stock!',
    openLabel: 'On',
    closedLabel: 'Off',

    // Price table tooltips
    salePriceRatioTip: 'Adds a percentage markup on top of cost (e.g. cost 80, rate 25 → sale 100).',
    fixedPriceTip: 'Fixed: you enter the final price directly; the rate field is not used.',
    saleRateTip: 'Percentage to add on top of cost. When type is "Percentage", sale price is calculated automatically.',
    saleFinalTip: 'Final sale price. With "Percentage" type it is auto-calculated; with "Fixed" you enter it directly.',
    buyPriceTip: 'Purchase price is based on cost. 0%: purchase = cost. Percentage: cost + rate. Negative rate or Fixed can go below cost.',
    buyRateTip: 'Percentage to add on top of cost. At 0 purchase equals cost; negative rate goes below cost.',
    buyFinalTip: 'Final purchase price. With "Percentage" type it is auto-calculated from cost; with "Fixed" you enter it directly.',
    dealerPriceTip: 'Dealer price is based on sale price. Percentage: discount from sale. Fixed: you enter the final price directly.',
    dealerRateTip: 'Percentage to deduct from sale price. With "Percentage" type, dealer price is auto-calculated.',
    dealerFinalTip: 'Final dealer price. With "Percentage" type it is auto-calculated; with "Fixed" you enter it directly.',
    selectStoreFirstTip: 'Select the store first. The product list loads based on the selected store.',
    searchNotAddedTip: 'Search and select from active products not yet added to this store.',
    marketPriceTip: 'Reference (strikethrough) price on the product card. Comes from the product record; independent of store price.',
    costUpdateTip: 'When cost changes, percentage-type sale and purchase prices are automatically recalculated.',
    stockRequiredTip: 'Stock required (physical/virtual/API)',
    stockRequiredOffTip: 'Off = sell without stock',
    apiSaleTip: 'Payment → provider order',
    apiStockTip: 'Storefront stock source',
    statusTip: 'Store status',

    // Product modal
    modalEditTitle: 'Edit Store Price',
    apiEnabled: 'Enable API',
    botEnabled: 'Enable Bot',
    pointSale: 'Sell with Points',
    selectStorePlaceholder: 'Select Store',
    selectStoreLabel: 'Select Store',
    selectProductPlaceholder: 'Select Product',
    selectProductLabel: 'Search and select product',
    selectStoreFirstHint: 'Select store first',
    virtualStockNotConnected: 'Not Connected',
    virtualStockSelectLabel: 'Select Virtual Stock',
    pointAmountLabel: 'Purchasable Point Amount',
    apiProviderHint: 'Search and select an external stock/supply API provider.',
    apiProviderLabel: 'API Provider',
    apiProviderSearch: 'Search API provider',
    turkpinGameHint: 'Game/category selection is required for TurkPin.',
    apiGameLabel: 'API Game',
    apiGameSearch: 'Search game',
    apiGameSelectFirst: 'Select API first',
    apiProductHint: 'Search and match the product from the selected provider.',
    apiProductLabel: 'API Product',
    apiProductSearch: 'Search API product',
    apiFieldMappingTitle: 'API Required Field Mapping',
    apiStoreFieldSelect: 'Select store field',
    apiFetchPriceFailed: 'Failed to fetch API price.',
    apiFetchPriceSuccess: 'Cost updated with API price.',
    apiFetchPriceError: 'Could not fetch API price',
    apiFetchPriceRequireFields: 'Select API provider and API product first.',
    apiTurkpinGameFirst: 'Select game first for TurkPin.',
    apiFetchPriceLabel: 'Fetch API Price',
    botProductLabel: 'Bot Product',
    botProductSearch: 'Select bot product',
    selectOption: 'Select',
    costRecalcLabel: 'Recalculate prices',
    marketPriceLabel: 'Market Price',
    currencyHint: 'Currency to be used for store pricing.',
    currencyLabel: 'Currency',
    salePriceTypeLabel: 'Sale Price Type',
    saleRateLabel: 'Sale Rate Amount',
    saleAutoLabel: 'Sale Price (Auto)',
    buyPriceTypeLabel: 'Purchase Price Type',
    buyRateLabel: 'Purchase Rate Amount',
    buyAutoLabel: 'Purchase Price (Auto)',
    dealerPriceTypeLabel: 'Dealer Price Type',
    dealerRateLabel: 'Dealer Rate Amount',
    dealerAutoLabel: 'Dealer Price (Auto)',
    saleLimitsTitle: 'Sale Hours & Sale Limits',
    saleLimitsHint: 'Fill these fields if you want the product to be on sale only during certain hours.',
    saleLimitsSection: 'Sale Limits',
    startHourLabel: 'Start Hour (0-23)',
    endHourLabel: 'End Hour (0-23)',
    minAmountLabel: 'Min. Amount',
    maxAmountLabel: 'Max. Amount',
    buyLimitsSection: 'Purchase Limits',
    priceUpdated: 'Store price updated.',
    productAdded: 'Product added to store.',
    priceUpdateFailed: 'Could not update',
    priceAddFailed: 'Could not add',
    editingRecordNotFound: 'Record to edit not found.',

    applications: {
      title: 'Store Applications',
      tabAll: 'All',
      tabPending: 'Pending',
      tabApproved: 'Approved',
      tabRejected: 'Rejected',
      statusPending: 'Pending',
      statusApproved: 'Approved',
      colFirm: 'Company',
      colContact: 'Contact',
      colWeb: 'Web',
      colDate: 'Application Date',
      noResults: 'No applications found.',
      review: 'Review',
      authorized: 'Contact Person',
      applicationDesc: 'Application Description',
      evaluation: 'Evaluation',
      adminNote: 'Admin Note',
      notePlaceholder: 'Optional note…',
      approveAndCreate: 'Approve & Create Store',
      approvedMsg: 'Application approved.',
      rejectedMsg: 'Application rejected.',
    },

    prices: {
      title: 'Store Product Prices',
      titleAriaLabel: 'Store product prices usage info',
      pageInfoTip: 'Double-click · multiple rows · bulk save · double-click again = cancel row · limits in modal',
      recordsCount: '{count} records',
      addProduct: 'Add Product to Store',
      allStores: 'All Stores',
      allCategories: 'All Categories',
      allVirtualStocks: 'All Virtual Stocks',
      unassignedVirtualStock: 'Virtual Stock Unassigned',
      allTypes: 'All Types',
      apiProducts: 'API Products',
      virtualStockProducts: 'Virtual Stock Products',
      allStatuses: 'All Statuses',
      storeFilterLabel: 'Store filter',
      categoryFilterLabel: 'Category filter',
      virtualStockFilterLabel: 'Virtual stock filter',
      typeFilterLabel: 'Product type filter',
      statusFilterLabel: 'Status filter',
      searchPlaceholder: 'Search product or store…',
      searchLabel: 'Search product or store',
      totalProducts: 'Total {total} products',
      showing: 'Showing {from}–{to}',
      perPage: 'Per page',
      perPageLabel: 'Products per page',
      deleteConfirm: 'Are you sure you want to delete this store price record?',
      deleteSuccess: 'Store price deleted.',
      deleteFailed: 'Could not delete',
    },

    commissions: {
      title: 'Marketplace Integration',
      tabRules: 'Commission Rules',
      tabSync: 'Synchronization',
      tabCalc: 'Calculator',
      allStores: 'All stores',
      newRule: 'New Rule',
      editRuleTitle: 'Edit Rule',
      newRuleTitle: 'New Commission Rule',
      ruleNameLabel: 'Rule Name',
      ruleNamePlaceholder: 'e.g. General Commission',
      storeLabel: 'Store',
      rateLabel: 'Rate (%)',
      fixedFeeLabel: 'Fixed Fee (₺)',
      minFeeLabel: 'Min. Commission (₺)',
      maxFeeLabel: 'Max. Commission (₺, 0=unlimited)',
      noRules: 'No commission rules yet.',
      colRuleName: 'Rule Name',
      colStore: 'Store',
      colCategory: 'Category',
      colRate: 'Rate',
      colFixed: 'Fixed',
      general: 'General',
      deleteRuleConfirm: 'Delete "{name}"?',
      testingConnection: 'Testing…',
      testConnection: 'Test Connection',
      pulling: 'Pulling…',
      pullOrders: 'Pull Orders',
      connectionError: 'Connection error.',
      ordersCount: '{count} orders pulled.',
      pullError: 'Failed to pull orders.',
      calcTitle: 'Commission Calculator',
      salePriceLabel: 'Sale Price (₺)',
      calculating: 'Calculating…',
      calcBtn: 'Calculate',
      salePrice: 'Sale Price',
      commissionRow: 'Commission (%{rate})',
      netEarnings: 'Net Earnings',
      selectStore: 'Select',
    },
  },

  // ── Invoices ──────────────────────────────────────────────────────────────
  invoices: {
    title: 'Invoices',
    totalRecords: 'Total {count} records',
    colInvoiceNo: 'Invoice No',
    colName: 'Full Name',
    colTax: 'VAT',
    colIssuedAt: 'Issue Date',
    colIntegrator: 'Integrator',
    colPdf: 'PDF',
    pdfDownload: 'Download PDF',
  },

  // ── Tickets ───────────────────────────────────────────────────────────────
  tickets: {
    customerRequests: 'Customer Requests',
    orderBased: 'Order-Based',
  },

  adverts: {
    title: 'Listing Management',
    advertCount: 'Total {count} listings',
    tabList: 'Listings',
    tabCategories: 'Categories',

    statusAll: 'All',
    statusPending: 'Pending',
    statusApproved: 'Approved',
    statusRejected: 'Rejected',
    statusSold: 'Sold',
    statusExpired: 'Expired',

    colTitle: 'Title',
    colCategory: 'Category',
    colUser: 'User',
    colPrice: 'Price',
    colStatus: 'Status',
    colEndDate: 'End date',
    colActions: 'Actions',

    searchLabel: 'Search',
    searchPlaceholder: 'Listing title',
    statusLabel: 'Status',
    categoryLabel: 'Category',

    approve: 'Approve',
    reject: 'Reject',
    delete: 'Delete',
    detail: 'Detail',
    loadError: 'Failed to load listings.',
    approveSuccess: 'Listing approved and published.',
    approveFailed: 'Failed to approve listing.',
    rejectSuccess: 'Listing rejected.',
    rejectFailed: 'Failed to reject listing.',
    deleteSuccess: 'Listing deleted.',
    deleteFailed: 'Failed to delete listing.',

    rejectModalTitle: 'Reject Listing',
    rejectConfirmDesc: 'are you sure you want to reject this listing?',
    rejectReasonPlaceholder: 'Rejection reason (optional)',
    rejecting: 'Rejecting…',
    approveAndPublish: 'Approve & Publish',
    approving: 'Approving…',

    newCategory: 'New Category',
    noCategoriesYet: 'No categories yet.',
    categoryNameLabel: 'Name',
    cloneSuccess: 'Category cloned.',
    cloneFailed: 'Failed to clone category.',
    categoryDeleteSuccess: 'Category deleted.',
    categoryDeleteFailed: 'Failed to delete category.',

    // AdvertRulesPage
    rulesPageTitle: 'Listing Rules',
    allCategoriesFilter: 'All Categories',
    newRuleButton: 'New Rule',
    colType: 'Type',
    colOrder: 'Order',
    ruleNotFound: 'No rules found.',
    ruleSaved: 'Saved.',
    ruleDeleted: 'Deleted.',
    ruleDeleteFailed: 'Could not delete.',
    ruleDeleteConfirm: 'Delete this?',
    ruleEditTitle: 'Edit Rule',
    ruleNewTitle: 'New Rule',
    ruleFormCategory: 'Category',
    ruleFormType: 'Type',
    ruleTypeInfo: 'Info',
    ruleTypeWarning: 'Warning',
    ruleTypeRule: 'Rule',
    ruleTypeSuccess: 'Positive',
    ruleTypeDanger: 'Banned',
    ruleTypeTip: 'Tip',
    ruleTypeNotice: 'Notice',
    ruleTypeSeller: 'Seller',
    ruleTypeBuyer: 'Buyer',
    ruleFormOrder: 'Order',
    ruleFormTitle: 'Title *',
    ruleFormWarning: 'Warning Text',
    ruleFormRules: 'Rules Text',
    ruleFormActive: 'Active',

    // AdvertCommentsPage
    commentsTitle: 'Seller / Product Reviews',
    commentSearchPlaceholder: 'Search product or user…',
    noComments: 'No reviews found.',
    productLabel: 'Product:',
    commentApproveSuccess: 'Approved.',
    commentRejectSuccess: 'Rejected.',
    commentDeleteSuccess: 'Deleted.',
    commentDeleteFailed: 'Could not delete.',
    rejectedApproveQ: 'Rejected — Approve?',
    showMore: 'Show full review',
    showLess: 'Show less',
    commentDeleteConfirm: 'Are you sure you want to delete this?',

    // AdvertCategoryFormPage
    catBackLink: 'Category List',
    catEditTitle: 'Edit Listing Category',
    catNewTitle: 'Add Listing Category',
    catClone: 'Clone',
    catCreate: 'Create',
    catSaving: 'Saving…',
    catSaveSuccess: 'Category updated.',
    catCreateSuccess: 'Category created.',
    catSaveFailed: 'Save failed.',
    catNameRequired: 'Category name is required.',
    catUploadFailed: 'Failed to upload image.',
    catClearFailed: 'Failed to delete image.',
    noImage: 'No Image',
    sectionBasicInfo: 'Basic Info',
    sectionPricing: 'Pricing & Limits',
    sectionDeliveryOpts: 'Delivery Options',
    sectionDescriptions: 'Descriptions',
    sectionCreateFields: 'Fields Required When Listing',
    sectionDeliveryFields: 'Fields Required on Delivery',
    sectionBuyerFields: 'Fields Required from Buyer',
    addField: 'Add Field',
    deliveryAdd: 'Add',
    noDeliveryOptions: 'No delivery options yet.',
    fieldNumber: 'Field #{index}',
    fieldInputType: 'Input Type',
    fieldFilterType: 'Filter Type (Marketplace)',
    fieldPlaceholder: 'Placeholder',
    fieldSortOrder: 'Sort Order',
    fieldSelectValues: 'Select Values (one per line)',
    flagRequired: 'Required',
    flagShowInCard: 'Show in Card',
    labelCatName: 'Category Name',
    labelSlug: 'Slug (URL)',
    labelListPreview: 'List Preview Name',
    labelParent: 'Parent Category',
    labelRootCategory: 'Root category',
    labelRegion: 'Service Region',
    labelAllRegions: 'All Regions',
    labelSimilar: 'Similar Category',
    labelSelectOption: 'Select',
    switchPublicChat: 'Public Chat',
    switchLimitedStock: 'Quantity Sale',
    switchUnlimitedStock: 'Unlimited Stock',
    switchModerator: 'Moderator Approval',
    labelMinPrice: 'Min. Price (₺)',
    labelMaxPrice: 'Max. Price (₺)',
    labelSaleLimit: 'Sale Limit',
    labelBuyLimit: 'Buy Limit',
    labelCommission: 'Commission %',
    labelDuration: 'Listing Duration (Days)',
    catDescLabel: 'Category Description',
    catDescPlaceholder: 'Category description…',
    catHowToUseLabel: 'How to Use?',
    catHowToUsePlaceholder: 'Usage instructions…',
    catMetaChars: '{count}/160 characters',
    imageCategoryLabel: 'Category Image',
    imageDefaultLabel: 'Default Listing Image',
    imagePreviewLabel: 'Category Preview Image',
    inputTypeText: 'Text',
    inputTypeLongText: 'Long Text',
    inputTypeNumber: 'Number',
    inputTypeSelect: 'Select',
    inputTypeCheckbox: 'Checkbox',
    filterTypeNone: 'No Filter',
  },

  coupons: {
    title: 'Coupons',
    total: 'Total {count}',
    newCoupon: 'Create discount coupon',
    createTitle: 'New coupon',
    bulkActions: 'Bulk coupon actions',
    bulkActivate: 'Activate selected',
    bulkDeactivate: 'Deactivate selected',
    bulkDelete: 'Delete selected',
    statTotal: 'Total coupons',
    statActive: 'Active coupons',
    statUsage: 'Total uses',
    statMonth: 'Created this month',
    colAmount: 'Discount',
    colTip: 'Type',
    colRestriction: 'Restriction',
    colMin: 'Minimum',
    colProductLimit: 'Item limit',
    colCouponCount: 'Coupon count',
    colUsed: 'Uses',
    colKind: 'Scope',
    colDealer: 'Dealer use',
    colCart: 'Suggest in cart',
    colHome: 'Suggest on home',
    colSalePrice: 'Sale price allowed',
    colValidUntil: 'Valid until',
    colCreated: 'Created',
    kindProduct: 'Product based',
    kindGeneral: 'General',
    restrictionYes: 'Yes',
    restrictionNo: 'No',
    unlimited: 'Unlimited',
    dealerUsage: 'Dealers can use this coupon',
    suggestCart: 'Suggest in cart',
    suggestHome: 'Suggest on homepage',
    allowSalePrice: 'Valid on specially priced products',
    productQtyLimit: 'Product quantity limit',
    editCoupon: 'Edit coupon',
    backAriaLabel: 'Back to coupon list',
    invalidId: 'Invalid coupon.',
    loadError: 'Failed to load coupon.',
    saveFailed: 'Save failed.',
    pageInfo: 'Page {current}/{last}',

    searchPlaceholder: 'Code or description',
    showExpired: 'Show expired',

    colCode: 'Code',
    colClass: 'Class',
    colTypeValue: 'Type / Value',
    colUsage: 'Usage',
    noCoupons: 'No coupons.',
    deleteConfirm: 'Are you sure you want to delete the "{code}" coupon?',
    statusToggleFailed: 'Failed to change status.',

    codeLabel: 'Coupon code',
    codeHint: 'The code cannot change after save. Create a new coupon for a new code.',
    classLabel: 'What it gives',
    classDiscount: 'Cart discount',
    classSpin: 'Wheel spin',
    classPoint: 'Points',
    discountTypeLabel: 'Discount type',
    typePercentage: 'Percentage',
    typeFixed: 'Fixed amount',
    typeFreeShipping: 'Free shipping',
    valueLabel: 'Value',
    valueFreeShippingHint: 'No amount is needed for free shipping',
    maxDiscountLabel: 'Discount cap',
    minOrderLabel: 'Minimum order',
    usageLimitLabel: 'Total uses',
    perUserLimitLabel: 'Uses per customer',
    startLabel: 'Starts',
    endLabel: 'Ends',
    requiresPhone: 'Phone verification',
    requiresEmail: 'Email verification',
    firstOrderOnly: 'First order only',
    sectionType: 'Coupon type',
    sectionTypeHint: 'Choose what the customer receives when they use this code.',
    sectionBasics: 'Basics',
    sectionBasicsHint: 'The code, a short note, and the dates the coupon is valid.',
    sectionLimits: 'Limits',
    sectionLimitsHint: 'A blank limit is not applied.',
    sectionDates: 'Validity',
    sectionDatesHint: 'A blank date means the coupon starts now or never expires.',
    sectionAudience: 'Who can use it',
    sectionAudienceHint: 'Leave the switches off if you do not want extra conditions.',
    sectionVisibility: 'Where it appears',
    sectionVisibilityHint: 'An enabled coupon is offered as a ready choice at checkout.',
    infoCode: 'The customer types this code in the cart. Use letters, numbers, and dashes. It cannot change after save.',
    infoClass: 'A cart discount lowers the total. A wheel spin adds an extra turn. Points load the loyalty balance.',
    infoType: 'Percentage takes a share of the cart, a fixed amount takes a set sum, and free shipping only removes the shipping fee.',
    infoValue: 'Enter 10 for a percentage to take 10 percent off. Enter 50 for a fixed discount of 50.',
    infoMax: 'The highest amount a percentage discount may reach. Enter 100 if 20 percent should stop at 100.',
    infoMin: 'The code is refused when the cart is below this amount. Leave it blank for no minimum.',
    infoUsage: 'How many times the code can be used in the store. Blank means unlimited.',
    infoPerUser: 'How many times the same customer can use this code.',
    infoQty: 'The code is refused when the cart quantity is above this number. Blank means no quantity cap.',
    infoStart: 'The code does not work before this date. Blank means it is valid immediately.',
    infoEnd: 'The code stops after this date. Blank means it does not expire.',
    infoPhone: 'Only customers who verified their phone can use it.',
    infoEmail: 'Only customers who verified their email can use it.',
    infoFirst: 'A customer who already has a completed order cannot use this code.',
    infoDealer: 'When on, seller accounts can use it too. When off, only regular customers can.',
    infoCart: 'When on, the code appears as a ready button on the checkout page.',
    infoHome: 'When on, the code is included in homepage suggestions.',
    infoSale: 'When off, the code is refused on products sold below the market price.',
    infoActive: 'A switched-off coupon is not accepted in the cart.',
    saving: 'Saving…',
    createSuccess: 'Coupon created.',
    updateSuccess: 'Coupon updated.',
    valueError: 'Check the value field.',
    codeRequired: 'Coupon code is required.',
  },

  expenses: {
    title: 'Expense Management',
    description: 'Track and report store expenses',
    addExpense: 'Add Expense',
    totalExpense: 'Total Expenses',
    paidAmount: 'Paid',
    pendingAmount: 'Pending',
    noExpensesTitle: 'No expenses yet',
    noExpensesDesc: 'Add your first expense to start financial tracking.',

    colTitle: 'Title',
    colCategory: 'Category',
    colAmount: 'Amount',
    colDate: 'Date',
    colStatus: 'Status',

    statusPending: 'Pending',
    statusPaid: 'Paid',
    statusCancelled: 'Cancelled',
    methodCash: 'Cash',
    methodBank: 'Bank',
    methodCard: 'Card',
    methodOther: 'Other',

    editExpense: 'Edit Expense',
    newExpense: 'New Expense',
    titleLabel: 'Title *',
    categoryLabel: 'Category',
    amountLabel: 'Amount (₺) *',
    paymentDateLabel: 'Payment Date *',
    statusLabel: 'Status',
    methodLabel: 'Method',
    deleteConfirm: 'Delete this expense?',
    deleteSuccess: 'Expense deleted.',
    deleteFailed: 'Failed to delete expense.',
  },

  points: {
    title: 'Points & Rewards',
    tabTransactions: 'Transaction History',
    tabAdjust: 'Manual Points',
    tabConfig: 'Settings',

    typeAll: 'All',
    typeEarn: 'Earned',
    typeSpend: 'Spent',
    typeExpire: 'Expired',
    typeAdminAdjust: 'Admin Adjustment',

    colUser: 'User',
    colType: 'Type',
    colAmount: 'Amount',
    colBalance: 'Balance',
    colDesc: 'Description',
    colDate: 'Date',
    noTransactions: 'No transactions found.',

    adjustDesc: 'Enter a user ID to manually add or subtract points.',
    userIdLabel: 'User ID *',
    amountLabel: 'Point Amount * (+ to add, - to subtract)',
    amountPlaceholder: '100 or -50',
    adjustDescLabel: 'Description *',
    descPlaceholder: 'Campaign bonus, correction…',
    applying: 'Applying…',
    applyButton: 'Apply Points Adjustment',
    adjustSuccess: 'Points adjustment applied successfully.',
    adjustError: 'An error occurred.',

    configDesc: 'Points rules are managed via',
    configFileDesc: 'and',
    configFileDesc2: '.',
    earnRateTitle: 'Earning',
    earnRateField: 'Points earn rate (%)',
    earnRateInfo: 'Share of the order total awarded as points. 5 means a 100 order earns 5 points. Leave empty to use the server default. 0 awards nothing.',
    earnRatePlaceholder: 'e.g. 5',
    earnRateSaved: 'Points earn rate saved.',
    earnRateSaveFailed: 'Could not save the points earn rate.',
    earnRateLabel: 'Earn rate (1 TRY = ? pts)',
    minOrderLabel: 'Minimum order amount',
    spendRateLabel: 'Spend rate (1 pt = ? TRY)',
    maxSpendRatioLabel: 'Max. points spend ratio',
    backendHint: 'To change, add to the backend',
    backendFileHint: 'file:',
  },

  wheel: {
    title: 'Spin Wheel',
    addSegment: 'Add Segment',
    tabSegments: 'Segments',
    tabPrizes: 'Prizes',
    totalProbWarning: 'Total probability: {total}% (must be 100%)',

    colColor: 'Color',
    colLabel: 'Label',
    colProbability: 'Probability',
    colReward: 'Reward',
    colValue: 'Value',
    colActive: 'Active',
    colActions: 'Actions',
    noSegments: 'No segments. Click "Add Segment" to begin.',

    colUser: 'User',
    colRewardType: 'Reward Type',
    colUsed: 'Redeemed',
    noPrizes: 'No prize records.',
    redeemed: 'Redeemed',
    notRedeemed: 'Pending',

    editSegment: 'Edit Segment',
    newSegment: 'New Segment',
    labelLabel: 'Label *',
    colorLabel: 'Color',
    probabilityLabel: 'Probability (%)',
    orderLabel: 'Order',
    rewardTypeLabel: 'Reward Type',
    valueLabel: 'Value',

    typePoints: 'Points',
    typeFreeSpin: 'Free Spin',
    typeDiscount: 'Discount',
    typeFreeProduct: 'Free Product',
    deleteConfirm: 'Delete this?',
    saving: 'Saving…',
    saved: 'Saved.',
    deleted: 'Deleted.',
    colDate: 'Date',
  },

  dashboard: {
    title: 'Dashboard',
    description: 'Your store\'s overall performance summary',
    loadError: 'Failed to load summary data. Check your session and store domain.',

    totalRevenue: 'Total Revenue',
    thisMonthRevenue: 'This Month Revenue',
    totalOrders: 'Total Orders',
    completedOrders: 'Completed',
    totalOrdersFrom: 'of {completed} total orders',
    unitLabel: 'Units',

    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',

    totalSales: 'Total Sales',
    totalIncome: 'Total Income',
    avgOrder: 'Avg. Order',
    monthlyGrowth: 'Monthly Growth',
    comparedToLastMonth: 'vs. last month',

    salesAnalysis: 'Sales Analysis',
    salesAnalysisDesc: 'Detailed analysis of all sales data',
    chartTotalOrders: 'Total Orders',
    chartCompleted: 'Completed',
    chartRevenue: 'Revenue (₺)',

    topCategories: 'Top Selling Categories',
    topCategoriesDesc: 'This month\'s sales performance',
    noOrdersThisMonth: 'No orders this month yet.',
    colCategory: 'Category',
    colSales: 'Sales',
    colRevenue: 'Revenue',
    colTrend: 'Trend',

    ordersPanel: 'Orders',
    todayNew: 'Today: {count} New',
    totalLabel: 'Total',
    pendingLabel: 'Pending',
    doneLabel: 'Done',

    orderStatusCompleted: 'Completed',
    orderStatusProcessing: 'Processing',
    orderStatusShipped: 'Shipped',
    orderStatusPending: 'New',
    orderStatusCancelled: 'Cancelled',
    orderStatusRefunded: 'Refunded',

    viewAllOrders: 'View All Orders',
    viewAllCustomers: 'View All Customers',

    topCustomersTitle: 'Last 7 Days',
    topCustomersDesc: 'Top spending customers',
    live: 'Live',
    noData: 'No data.',

    activeProducts: 'Active Products',
    customers: 'Customers',
    weekOrders: 'Orders This Week',
    newCustomers7d: 'New Customers (7d)',

    orderStatuses: 'Order Statuses',
    completionRate: 'Completion Rate',
    decrease: 'decrease',
    noPeriodData: 'No data for this period.',

    topProducts: 'Top Selling Products',
    noSalesData: 'No sales data for this period.',
    colProduct: 'Product',
    colQty: 'Units Sold',
  },

  reports: {
    filterStart: 'Start',
    filterEnd: 'End',
    filterButton: 'Filter',
    loadError: 'Failed to load report data.',

    netRevenue: 'Net Revenue',
    grossPrefix: 'Gross:',
    totalOrders: 'Total Orders',
    completedSuffix: 'completed',
    orderSuffix: 'order(s)',
    refunds: 'Refunds',
    newCustomers: 'New Customers',
    thisPeriod: 'this period',

    trendTitle: 'Revenue & Order Trend',
    noTrendData: 'No data for this period.',
    orderBarName: 'Orders',
    completedBarName: 'Completed',
    revenueLineName: 'Revenue (₺)',

    orderStatuses: 'Order Statuses',
    completionRate: 'Completion Rate',
    statusCompleted: 'Completed',
    statusPending: 'Pending',
    statusProcessing: 'Processing',
    statusShipped: 'Shipped',
    statusCancelled: 'Cancelled',
    statusRefunded: 'Refunded',

    topProductsTitle: 'Top Selling Products',
    noTopProducts: 'No sales data for this period.',
    colRank: '#',
    colProduct: 'Product',
    colQty: 'Units Sold',
    colRevenue: 'Revenue',
    colTrend: 'Trend',

    // Stock reports
    stockTitle: 'Stock Reports',
    totalStocks: 'Total {count} stock items',
    filterAll: 'All Stocks',
    filterLow: 'Low Stock',
    filterOut: 'Out of Stock',
    attention: 'Warning',
    stockLoadError: 'Failed to load stock data.',
    colVariant: 'Variant',
    colProductCode: 'Product Code',
    colSalePrice: 'Sale Price',
    colCostLabel: 'Cost',
    colCurrency: 'Currency',
    noLowStock: 'No low stock items.',
    noOutStock: 'No out of stock items.',
    noStock: 'No stock found.',

    // Member reports
    memberTitle: 'Member Reports',
    totalMembers: 'Total {count} members',
    kpiTotalMembers: 'Total Members',
    kpiActive: 'Active',
    kpiInactiveSuspended: 'Inactive / Suspended',
    kpiWithBalance: 'With Balance',
    accountStatus: 'Account Status:',
    memberLoadError: 'Failed to load member data.',
    colEmail: 'Email',
    colFullName: 'Full Name',
    colBalance: 'Balance',
    colRegistered: 'Registration Date',
    noMembers: 'No members found.',
    memberStatusActive: 'Active',
    memberStatusInactive: 'Inactive',
    memberStatusSuspended: 'Suspended',
    allMemberStatuses: 'All statuses',
  },

  analytics: {
    title: 'Analytics',
    tabOverview: 'Overview',
    tabCohort: 'Cohort',
    tabFunnel: 'Conversion Funnel',
    loadError: 'Failed to load data.',

    totalViews: 'Total Views',
    uniqueVisitors: 'Unique Visitors',
    topSearch: 'Top Search',
    topProduct: 'Top Product',

    dailyViewsTitle: 'Daily Page Views',
    deviceTitle: 'Device Breakdown',
    browserTitle: 'Browser Breakdown',
    topSearchesTitle: 'Top Searches',
    topPagesTitle: 'Most Visited Pages',
    topProductsTitle: 'Most Viewed Products',

    colRank: '#',
    colPage: 'Page',
    colViews: 'Views',
    colProduct: 'Product',
    colOrders: 'Orders',
    colRevenue: 'Revenue',

    mobile: 'Mobile',
    tablet: 'Tablet',
    desktop: 'Desktop',
    noData: 'No data',

    cohortTitle: 'User Retention Cohort',
    cohortDesc: 'Groups by first order month; shows the percentage of users who placed another order in subsequent months',
    monthsLabel: 'Months:',
    cohortHeader: 'Cohort',
    cohortSize: 'Size',
    month0: 'Month 0',
    noOrderData: 'No order data found for the selected period.',

    funnelTitle: 'Sales Conversion Funnel',
    funnelDesc: 'Step-by-step conversion rate from visitor to completed payment',
    funnelChartTitle: 'Users per Step',
    userAxisLabel: 'Users',
    percentTotal: '{rate}% of total',
    dropRate: '−{rate}% drop',
  },
}
